import { AfterContentInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild, Injectable, HostListener } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { MatExpansionPanel } from '@angular/material/expansion';
import { IngestConfigViewModel } from 'src/app/views/import-data/import-data.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { FileDataConnectorViewModel } from 'src/app/views/connectors/file/file-data-connector/file-data-connector.component';
import { BaseComponent } from 'src/app/base/base.component';
import { ActivatedRoute } from '@angular/router';
import {v4 as uuidv4} from 'uuid';
import { ColumnDefinition } from 'src/app/domainObjects/columnDefinition';
import DatabaseType, { DataConnector, DataConnectorType, DatabaseConnectorInfo, FeatherDataConnectorInfo, FileDataConnectorInfo, MySqlDataConnectorInfo, OracleDataConnectorInfo, ParaquetDataConnectorInfo, VerticaDataConnectorInfo } from 'src/app/domainObjects/dataConnector';
import { GetColumnsRequest } from 'src/app/messaging/getColumnsRequest';
import { ConfigService } from 'src/app/services/config/config.service';
import { DataConnectorMapping } from 'src/app/domainObjects/dataConnectorMapping';
import { NewSingleStringValueDialogComponent } from 'src/app/views/shared/new-single-string-value-dialog/new-single-string-value-dialog.component';
import { ConfigViewModelService } from 'src/app/services/configViewModel/config-view-model.service';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { MapperFlowLayoutComponent, TargetColumnChangedEventData } from '../../mapper/mapper-flow-layout/mapper-flow-layout.component';
import { ConfigWorkFlowStepModel, ConfigDetailComponent, ConfigDetailViewModel } from 'src/app/views/config/config-detail/config-detail.component';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { DataFarmType, DataFarmTypeUtil } from 'src/app/domainObjects/dataFarmType';
import { ColumnMapDefinitionModel } from 'src/app/model/columnMapDefinitionModel';
import { ImportDataViewModel } from 'src/app/viewModels/importDataViewModel';
import { DataSourceType } from 'src/app/domainObjects/dataSourceType';
import { ColumnInfo, IPreviewTableDelegate, PreviewTableComponent } from 'src/app/views/preview-table/preview-table.component';
import { ColumnFilterInfo } from 'src/app/views/previewTable/filterUI/column-filter/column-filter.component';
import { PreviewDataOptions } from 'src/app/domainObjects/previewDataOptions';
import { GetCacheKeyRequest, GetDataFarmPreviewIngestRequest, GetDataFarmPreviewRequest } from 'src/app/messaging/getDataFarmPreviewRequest';
import { ExcelDataConnectorViewModel } from '../../../connectors/excel/excel-data-connector/excel-data-connector.component';
import { ExcelDataConnector } from '../../../../domainObjects/dataConnector';
import { EventBrokerService, EventData } from '../../../../services/eventBroker/event-broker.service';
import { SortInfo } from 'src/app/domainObjects/sortInfo';
import { SortBuilderComponent } from 'src/app/views/transform/sort-builder/sort-builder.component';
import { UntypedFormControl } from '@angular/forms';
import { ColumnFilter } from 'src/app/domainObjects/columnFilter';
import { OptionItem } from '../../../../model/optionItem';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ColumnMap } from '../../../../domainObjects/columnMap';
import { PreviewData } from 'src/app/domainObjects/previewData';
import { UserDataService } from 'src/app/services/user-data-service';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable, of, Subscription, throwError } from 'rxjs';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { SharedService } from 'src/app/services/shared.service';
import { UpdateIngestNodesStatusRequest } from 'src/app/messaging/updateIngestNodesStatusRequest';
import { UpdateingestnodestatusService } from 'src/app/services/updateingestnodestatus.service';
import { DataTypeConverter, DeduplicateRows, DurationBuilder, GeneralParameter } from 'src/app/domainObjects/ingestTransforms';
import { DataTransformerConfig } from 'src/app/domainObjects/dataTransformConfig';
import { ConfigColumnMap } from 'src/app/domainObjects/configColumnMap';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { FeatherDataConnectorViewModel } from 'src/app/views/connectors/feather/feather.component';
import { DatabaseDataConnectorViewModel } from 'src/app/views/connectors/database/sql-data-connector/sql-data-connector.component';
import { OracleDataConnectorViewModel } from 'src/app/views/connectors/database/oracle-data-connector/oracle-data-connector.component';
import { MySqlDataConnectorViewModel } from 'src/app/views/connectors/database/mysql-data-connector/mysql-data-connector.component';
import { VerticaDataConnectorViewModel } from 'src/app/views/connectors/database/vertica-data-connector/vertica-data-connector.component';
import { ParquetDataConnectorViewModel } from 'src/app/views/connectors/parquet-data-connector/parquet-data-connector.component';
import { CacheKeyType, PreviewType } from 'src/app/domainObjects/transformType';
import { GetFilteredselcolvalsRequest } from 'src/app/messaging/getFilteredselcolvalsRequest';
import { ExportColumnInfo } from 'src/app/viewModels/exportViewModel';
import { CreateMasterColMappingsRequest } from 'src/app/messaging/createMasterColMappingsRequest';
import { MapLibraryColmatchSelectionItem } from 'src/app/views/shared/maplibrary/maplibrary.component';
import { MaplibraryComponent } from 'src/app/views/shared/maplibrary/maplibrary.component';
import { GetUnifiedColmappingMapLibRequest } from 'src/app/messaging/getUnifiedColmappingMapLibRequest';
import { MasterColumnMapping } from 'src/app/messaging/getUnifiedColmappingMapLibResponse';
import { Overlay } from '@angular/cdk/overlay';
import { isFtpServiceMissing } from 'src/app/views/shared/ftp-service-select/ftp-service-select.component';

// import * as fs from 'fs';


export class SelectedIngestFarmChangedEvent implements EventData {
  ingestFarmId: string;

  constructor(ingestFarmId: string) {
    this.ingestFarmId = ingestFarmId;
  }
}

export enum Step {
  dataConnectorStep,
  ingestTransformStep,
  mapperStep,
  targetFarmStep,
  ingestPreviewStep
}

export class StepModel {
  step: Step;
  isComplete: boolean;
  name: string;

  constructor(step: Step, name: string) {
    this.step = step;
    this.name = name;
  }
}

class ViewModel {
  routerLink: string;
  steps: StepModel[];
  isLoadingColumns = false;

  dataTransformConfigViewModel: DataTransformConfigViewModel;
  loadColumnsFailed = false;
  lastErrorMessage = null;
  selectedIngestConfig?: IngestConfigViewModel = null;
  dataFarmTypes: DataFarmType[] = [];

  sortInfo?: SortInfo[];
  activeFilters?: ColumnFilter[];
  masterMappings?: OptionItem[];
  canSyncColumnsToMaster = false;
  selectedIngestFarmGuid?:string ;

  public get hasColumns(): boolean {
    return this.selectedIngestConfig.columnMap?.length > 0;
  }

  public get hasTargetDataFarm(): boolean {
    return this.selectedIngestConfig.columnMap?.length > 0;
  }

  constructor() {
    
    
    this.steps = [
        new StepModel( Step.dataConnectorStep, 'Data Connector'),
        // new StepModel( Step.targetFarmStep, 'Target Data Farm'),
        new StepModel( Step.mapperStep, 'Column Mapper'),
        // new StepModel( Step.ingestTransformStep, 'Ingest Transform'),
        new StepModel( Step.ingestPreviewStep, 'Data Preview'),
        new StepModel( Step.ingestTransformStep, 'Ingest Transforms'),
      ];

      
  }

  completeStep(stepModel: StepModel): void {
    stepModel.isComplete = true;
  }

  addIngestConfig(config: IngestConfigViewModel): void {
    this.dataTransformConfigViewModel.ingestConfigs.push(config);
  }

  updateMasterMappings(): void {

    this.masterMappings = [];
    this.masterMappings.push(new OptionItem('', 'Working Map'));

    const items = this.dataTransformConfigViewModel.ingestConfigs
      .filter(i => i.guid !== this.selectedIngestConfig?.guid)
      .filter(i => this.hasExactSameSourceColumns(i.columnMap, this.selectedIngestConfig.columnMap))
      .map(i => new OptionItem(i.guid, i.name));

    items.forEach(i => this.masterMappings.push(i));
    this.canSyncColumnsToMaster = this.masterMappings?.length > 1;

  }

  private hasExactSameSourceColumns(
    columnMapA: ColumnMapDefinitionModel[],
    columnMapB: ColumnMapDefinitionModel[]): boolean {
      const list1 = [...columnMapA].sort( (a, b) => a.columnName < b.columnName ? -1 : 0).map( c => c.columnName);
      const list2 = [...columnMapB].sort( (a, b) => a.columnName < b.columnName ? -1 : 0).map( c => c.columnName);

      return JSON.stringify(list1) === JSON.stringify(list2);
  }
}

@Injectable({
  providedIn: 'root'
})

@Component({
    selector: 'app-ingest-work-flow-layout',
    templateUrl: './ingest-work-flow-layout.component.html',
    styleUrls: ['./ingest-work-flow-layout.component.css'],
    standalone: false
})
export class IngestWorkFlowLayoutComponent extends BaseComponent implements OnInit, AfterContentInit, IPreviewTableDelegate {
  @ViewChild('stepperVertical') stepperVertical: MatStepper;
  @ViewChild('mapperLayout') private mapperLayout: MapperFlowLayoutComponent;
  @ViewChild('mapperStep') private mapperStepPanel: MatExpansionPanel;
  @ViewChild('previewTable') previewTable: PreviewTableComponent;
  @ViewChild('rawDataFarmPreviewTable') rawDataFarmPreviewTable: PreviewTableComponent;
  @ViewChild('inputDataFarmPreviewTable') inputDataFarmPreviewTable: PreviewTableComponent;
  @ViewChild('outputDataFarmPreviewTable') outputDataFarmPreviewTable: PreviewTableComponent;
  @Output() dataConnectorStateChanged = new EventEmitter<DataTransformConfigViewModel>();
  @Output() saveIngest = new EventEmitter<string>();

  @Input() dataTransformConfigViewModel: DataTransformConfigViewModel;
  @Input() configWorkflowStep: ConfigWorkFlowStepModel;
  @Input() configWorkflowStepper: MatStepper;
  /** Set by the parent ConfigDetailComponent from its own isReadOnly getter.
   * Disables Add/Rename/Delete Ingest Farm, Run Auto Mapper, Map Library,
   * Clear Map, and Add Placeholder Column below — the mutating actions in
   * this step. Loading/refreshing/exporting stay enabled (read-only-safe). */
  @Input() isReadOnly: boolean = false;

  sortCtrl = new UntypedFormControl('');

  DataFarmTypeUtil = DataFarmTypeUtil;
  DataFarmType = DataFarmType;
  viewModel = new ViewModel();
  configviewModel: ConfigDetailViewModel;
  previewDataViewModel = new ImportDataViewModel();
  columnDefinitions: ColumnDefinition[];
  lastSelectedIngest?: IngestConfigViewModel = null;
  ConfigDetailComponent =  ConfigDetailComponent;
  fileExists: boolean | undefined = true;
  input_File_Path?: string  = '';
  input_File_Separate?: string  = '';
  rawDataColumnsCount: number = 0;
  inputDataColumnsCount: number = 0;
  outputDataColumnsCount: number = 0;
  isIngestNodeSaved: boolean = false;
  selectedIndex: number = 0;
  activeSortsSet: SortInfo[]=[];
  configMappedCols: ConfigColumnMap[] = [];
  currentPlaceholdrCols: ConfigColumnMap[] = [];
  isAutoMapApplied: boolean = false;
  isLoadConnectorColumnsClicked: boolean = false;
  isClearMapButtonClicked: boolean = false;
  // Snapshot of the Clear-Map state when the Map Library is opened, so Cancel can
  // revert the mapper to how it was (cleared) instead of reloading a mapping.
  private clearMapStateBeforeMapLibrary: boolean = false;
  ingestConfigGUID: string = "";
  isClearSortFilterAfterIngestSaved: boolean = false;
  private hasAlreadyShownError = false;
  currentNodeMapsList: MapLibraryColmatchSelectionItem[] = [];
  allMapsList: MapLibraryColmatchSelectionItem[] = [];

  configViewModelObserver = {
    next: (x: DataTransformConfigViewModel) => {
      //console.log('DataTransformConfigViewModel Observer got a next value: ' + x);
      this.checkAndEnableDeltebtnforPlaceholdrCols();
      if (this.viewModel.dataTransformConfigViewModel === x) {
        return;
      }

      this.viewModel.dataTransformConfigViewModel = x;
      this.dataTransformConfigViewModel = x;

      // Reselect ingest as the it's parent has changed in memory. The previously selected farm's
      // guid can be gone (e.g. an Ingest Config import took over that slot with a new guid) — fall
      // back to whatever is currently selected rather than dropping to undefined.
      const reselected = this.dataTransformConfigViewModel.ingestConfigs
        .find(i => i.guid === this.viewModel.selectedIngestConfig?.guid);
      this.viewModel.selectedIngestConfig = reselected ?? this.viewModel.selectedIngestConfig;
    },
    error: (err: Error) => console.error('Observer got an error: ' + err),
    complete: () => console.log('Observer got a complete notification'),
  };
  private subscription!: Subscription;
  private configVmSub: Subscription;
  // Kept as a field so the same reference can be passed to removeEventListener in ngOnDestroy.
  private readonly onBeforeUnload = () => {
    this.showPlaceholderNotMappedWarning("mapper");
  };
  selectedMapType: string;
  selectedIngestGUID: string;
  
  constructor(
    private http: HttpClient,
    private activeRoute: ActivatedRoute,
    matDialog: MatDialog, private overlay: Overlay,
    private configService: ConfigService,
    errorLogger: ErrorReportingService,
    private snackBar: MatSnackBar,
    private configViewModelService: ConfigViewModelService,
    private userData: UserDataService,
    private changeDet: ChangeDetectorRef,
    private sharedService: SharedService,
    private updateingestnodestatusService: UpdateingestnodestatusService,
    private eventBroker: EventBrokerService) {
    super(errorLogger, matDialog);
    const ingstConfigGUID = this.userData.getSelectedNodeDetails().configGuid;
    if (ingstConfigGUID == undefined) {
      this.ingestConfigGUID = "";
    } else {
      this.ingestConfigGUID = ingstConfigGUID;
    }
  }

  onMapperTargetColumnChanged(event: TargetColumnChangedEventData): void {
    // Populate the current mappings in the local variable...
    // we need to sync the column map
    // if this ingest config is a master, we should update all the dependent column maps
    if(event.columnName.startsWith("Placeholder")){
      const placeholdrColsList = this.configMappedCols.find(configmapcol => configmapcol.sourceColumnName == event.columnName)
      console.log(placeholdrColsList)
      if(placeholdrColsList == undefined) {
        this.currentPlaceholdrCols.push(new ConfigColumnMap(event.columnName, event.targetColumnName))
      }
    }
    const dependents = this.viewModel.dataTransformConfigViewModel.ingestConfigs
      .filter( i => i.masterColumnMapGuid === event.ingestConfig.guid);

    // we have to update all these to the master column map
    if (dependents.length > 0) {
      dependents.forEach(d => d.syncToMasterMap(event.ingestConfig));
    }
  }

  onMasterMappingChanged(event: any): void {
    const masterMapGuid = this.viewModel.selectedIngestConfig?.masterColumnMapGuid;
    const masterMap = this.dataTransformConfigViewModel.ingestConfigs.find(i => i.guid === masterMapGuid);

    if (masterMapGuid?.length > 0) {
      if (masterMap.masterColumnMapGuid === this.viewModel.selectedIngestConfig.guid) {
        this.viewModel.selectedIngestConfig.masterColumnMapGuid = null;

        this.snackBar.open(`Cannot sync this column map to selected master map as it would create a circular reference`, 'Got it', {
          duration: 7000,
          panelClass: 'snackbar-error'
        });
        return;
      }

      // sync the master mapping to the selected ingest config
      this.showConfirmDialog(
        'Sync Column Mapping?',
        `Are you sure you want to sync this column map to a master map?`, (confirmed) => {
        if (confirmed) {
          //console.log('Syncing column map to ' + masterMapGuid);
          
          if (masterMap) {
            this.viewModel.selectedIngestConfig?.syncToMasterMap(masterMap);
            this.mapperLayout.refreshLayout();
          } else {
            throw new Error('Unable to find master map by guid: ' + masterMapGuid);
          }
        }
      });
    }
  }
//Preview Table Delegate
  async onRefreshClicked(sender: PreviewTableComponent): Promise<void> {
    // Download the data for the previewTable
    if (sender === this.rawDataFarmPreviewTable) {
      await this.refreshRawDataFarmPreviewAsync(sender);
    }else if (sender === this.inputDataFarmPreviewTable) {
      await this.refreshInputDataFarmPreviewAsync(sender);
    }else if (sender === this.outputDataFarmPreviewTable) {
        await this.refreshOutputDataFarmPreviewAsync(sender);
    }else if (sender === this.previewTable){
    }
  }

  async onPageChanged(sender: PreviewTableComponent, totalRows: number, pageSize: number, pageIndex: number): Promise<number> {
    if (sender === this.rawDataFarmPreviewTable) {
      await this.refreshRawDataFarmPreviewAsync(sender);
    }else if (sender === this.inputDataFarmPreviewTable) {
      await this.refreshInputDataFarmPreviewAsync(sender);
    }else if (sender === this.outputDataFarmPreviewTable) {
        await this.refreshOutputDataFarmPreviewAsync(sender);
    }else if (sender === this.previewTable){
    }
    return totalRows;
  }

  async onShowFilter(sender: PreviewTableComponent, columnName: string): Promise<void> {
    if(sender.activeFilterSet == undefined || sender.activeFilterSet.length == 0) {
      const busyIndicator = this.showBusyDialog('Please wait...');
      var cachekeyRequest:GetCacheKeyRequest=null;
      if(sender === this.rawDataFarmPreviewTable) {
        cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.ingestRaw);
      }else if (sender === this.inputDataFarmPreviewTable) {
        cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.ingestInput);
      }else if (sender === this.outputDataFarmPreviewTable) {
        this.isClearSortFilterAfterIngestSaved = false;
        cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.ingestOutput);
      }

      try{
        var request = new GetFilteredselcolvalsRequest(
          cachekeyRequest.userId,
          cachekeyRequest.orgId,
          cachekeyRequest.refineryId,
          cachekeyRequest.nodeId,
          cachekeyRequest.transformId,
          cachekeyRequest.cacheKeyType,
          columnName);
        await sender.fetchselectedcolsvalsfrmAPI(request);
      } catch(ex) {
        console.error('Error fetching data:', ex);
        this.displayError('Failed to fetch filter values. Please try again later.',"Failed to fetch");
      } finally {
        busyIndicator.close();
      }
    } else {
         sender.applyStackFilters(columnName);
    }
  }

  async onApplyFilter(sender: PreviewTableComponent, activeFilterSet: ColumnFilterInfo[], info: ColumnFilterInfo): Promise<void> {
    // const busyIndicator = this.showBusyDialog('Please wait...');

    if (!this.viewModel.activeFilters) {
      this.viewModel.activeFilters = [];
    }
    // // remove existing filter by columnName
     this.viewModel.activeFilters = this.viewModel.activeFilters.filter(f => f.field !== info.columnName);

    // // add new filter to active set
    const columnFilter = new ColumnFilter();
    columnFilter.field = info.columnName;
    columnFilter.values = info.values;

    this.viewModel.activeFilters.push(columnFilter);

    // await this.refreshInputDataFarmPreviewAsync(this.previewTable);

    // busyIndicator.close();
    const busyIndicator = this.showBusyDialog('Please wait...');
     if(sender == this.rawDataFarmPreviewTable) {
      await this.refreshRawDataFarmPreviewAsync(sender);
     } else if (sender === this.inputDataFarmPreviewTable) {
      await this.refreshInputDataFarmPreviewAsync(sender);
    } else if (sender === this.outputDataFarmPreviewTable) {
      await this.refreshOutputDataFarmPreviewAsync(sender);
    } else if (sender === this.previewTable){
      //await this.runTransform(this.previewTable.activeFilterSet, this.outputDataFarmPreviewTable.activeFilterSet, false);
    }
    busyIndicator.close();
  }

  async onClearFilter(sender: PreviewTableComponent, activeFilterSet: ColumnFilterInfo[], columnName: string): Promise<void> {
    const busyIndicator = this.showBusyDialog('Please wait...');
    // remove existing filter by columnName
    if(this.viewModel.activeFilters){
      this.viewModel.activeFilters = this.viewModel.activeFilters.filter(f => f.field !== columnName);
    }
   // await this.refreshInputDataFarmPreviewAsync(this.previewTable);
   if(sender == this.rawDataFarmPreviewTable) {
    await this.refreshRawDataFarmPreviewAsync(sender);
   } else if (sender === this.inputDataFarmPreviewTable) {
    await this.refreshInputDataFarmPreviewAsync(sender);
  } else if (sender === this.outputDataFarmPreviewTable) {
     await this.refreshOutputDataFarmPreviewAsync(sender);
  } else if (sender === this.previewTable){
    //await this.runTransform(this.previewTable.activeFilterSet, this.outputDataFarmPreviewTable.activeFilterSet, false);
  }

    busyIndicator.close();
  }

  async onApplySort(sender: PreviewTableComponent, sortData: SortInfo[]): Promise<void> {
    this.activeSortsSet = sortData;
  }

  async onClearAllSortFilter(sender: PreviewTableComponent): Promise<void> {
    this.activeSortsSet = [];
    this.viewModel.activeFilters=[];
  }

  getClassForRow(sender: PreviewTableComponent, row: any, colInfo: ColumnInfo, columns: ColumnInfo[]): string {
    return null;
  }
//Preview Table Delegate End
  async removeSortInfo(sortInfo: SortInfo): Promise<void> {
    const index = this.viewModel.sortInfo?.indexOf(sortInfo);

    if (index >= 0) {
      this.viewModel.sortInfo?.splice(index, 1);
      await this.refreshInputDataFarmPreviewAsync(this.previewTable);
    }
  }

  showSortBuilder(): void {
    const dialog = this.matDialog.open(SortBuilderComponent, {
      data: {
        fields: this.viewModel.selectedIngestConfig?.columnMap
          .filter(t => t.targetColumnName !== null && t.targetColumnName.length > 0)
          .map(c => c.targetColumnName),
        sortItems: [...this.viewModel.sortInfo ?? []] // make copy of array so it doesn't edit actual list
      }
    });

    dialog.afterClosed().subscribe(async result => {
      if (!result) {
        return;
      }

      const items = result.sortItems;
      this.viewModel.sortInfo = items;
      this.sortCtrl.setValue(null);
      await this.refreshInputDataFarmPreviewAsync(this.previewTable);
    });
  }

  async refreshInputDataFarmPreviewAsync(sender: PreviewTableComponent): Promise<void> {
    var blankDataPreview = new PreviewData();
    blankDataPreview.columns = [{id: 0, index: 0, columnName: '', dataType: '', pyDataType: '', targetColumnName: '', description: ''}]
    blankDataPreview.rows = {field : ""}
    blankDataPreview.totalRows = 0
    sender.bindData(blankDataPreview, 'No input preview data');

    const state = history.state;
    const configJsonObject =this.userData.getSelectedConfigJson(); //state.config;
    const configGuid = configJsonObject?.guid;
    
     if (configGuid) {
          var config: DataTransformerConfig = DataTransformerConfig.fromJSON(configJsonObject);    
          this.configviewModel = new ConfigDetailViewModel(config);
     } else {
          this.configviewModel = new ConfigDetailViewModel();
          this.configviewModel.dataTransformConfigViewModel = new DataTransformConfigViewModel();
     }

    let generalParameter = this.viewModel.dataTransformConfigViewModel.GeneralParameter;
    sender.isGettingData.next(true);

    try {
      const colMap = this.viewModel.selectedIngestConfig.columnMap?.map(c => {
        return c.toColumnMapDefinition();
      });
      if(this.viewModel.selectedIngestConfig.dataConnector){
        console.log(`====this.viewModel.selectedIngestConfig.dataConnector===${JSON.stringify(this.viewModel.selectedIngestConfig.dataConnector)}==`);
        const dataConnectorMapping = new DataConnectorMapping(
          this.viewModel.selectedIngestConfig.id,
              this.viewModel.selectedIngestConfig.name,
              this.viewModel.selectedIngestConfig.targetDataFarm,
              this.viewModel.selectedIngestConfig.dataConnector.toDataConnector(),
              colMap,
              this.viewModel.selectedIngestConfig.guid,
              this.viewModel.selectedIngestConfig.masterColumnMapGuid,
              state.refineryConfigGuid,
              state.nodeId,
              state.nodename,
              state.nodeType,
              this.viewModel.selectedIngestConfig.isMultiTabIngest,
              this.viewModel.selectedIngestConfig.excelTurboMode,
              this.viewModel.selectedIngestConfig.ingestAll,
              this.viewModel.selectedIngestConfig.sampleStart,
              this.viewModel.selectedIngestConfig.sampleEnd,

            );
        const filters = sender.activeFilterSet?.map(f => {
          const filterInfo = new ColumnFilter();
          filterInfo.field = f.columnName;
          filterInfo.values = f.values;
          return filterInfo;
        });
        const sortInfo = this.activeSortsSet;
        const options = new PreviewDataOptions(sender.pageIndex, sender.rowsPerPage, sortInfo,filters);
        this.userData.setIngestId(this.viewModel.selectedIngestConfig.guid);
        const cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.transInput);
        const request = new GetDataFarmPreviewIngestRequest(
          cachekeyRequest.userId,
          cachekeyRequest.orgId,
          cachekeyRequest.refineryId,
          cachekeyRequest.nodeId,
          cachekeyRequest.cacheKeyType,
          options,
          generalParameter,
          dataConnectorMapping);
        const response = await this.configService.getInputDataFarmPreviewAsync(request);
        if(response.data == null && response.errorMsg.length > 0) {
          throw new Error(response.errorMsg);
        } else {
          this.inputDataColumnsCount = response.data.columns.length;
          this.checkAndEnableDeltebtnforPlaceholdrCols();
          sender.bindData(response.data, 'No input preview data');
        }
      }
    } catch (err: any) {
      if (err.message?.includes('DataFrame is empty')
        || err.message?.includes('NoneType')
        || err.message?.includes('failed to load data frame from file')
        || err.message?.includes('No such file or directory')) {
          this.displayError("  The file is empty or not found. Please check the file path.","Error.");
      } else if (err.message?.includes('JSONDecodeError') || err.message?.includes('Expecting value')) {
        this.displayError(
          'The refinery configuration file could not be read — it may be empty or corrupted. Please verify the refinery configuration and try again.',
          'Error.', err);
      } else {
        this.displayError('Failed to get input data farm preview', 'Error', err);
      }
    } finally {
      sender.isGettingData.next(false);
    }
  }

  ngOnInit(): void {
    //Check if any blank placeholder is there in the mapper, then remove them before/when the browser is closed by the user.
    window.addEventListener('beforeunload', this.onBeforeUnload);

    this.subscription = this.sharedService.getEvent().subscribe(async data => {
      this.changeDet.detectChanges();
      
      if(data == "save_ingestbtn_clicked" || data == "cancel_dialog_clicked") {
        this.showPlaceholderNotMappedWarning("mapper");
        if(data == "cancel_dialog_clicked") {
          this.mapperLayout.refreshLayout();
        }
      } else if(data == "reset_node_successfully"){
        // Reset Node cleared the node cache — empty the Raw/Input/Output previews
        // so they no longer show stale rows for a cache that no longer exists.
        this.clearAllIngestPreviews();
      } else if(data == "ingestnode_saved_success"){
        /*This block of code refreshes the Raw, Input and Output Previews
          if the analyst clicks on the Save & Ingest Data button 
          and have not clicked on the Refresh Preview before.
         */ 
          this.isAutoMapApplied = false;
          const busyIndicator = this.showBusyDialog('Loading Data...');
          try {
            this.refreshRawDataFarmPreviewAsync(this.rawDataFarmPreviewTable);
            this.refreshInputDataFarmPreviewAsync(this.inputDataFarmPreviewTable);
            this.isClearSortFilterAfterIngestSaved = true;
            await this.refreshOutputDataFarmPreviewAsync(this.outputDataFarmPreviewTable);
          } catch (err: any) {
            console.log("Error Loading data..,", err);
          } finally {
            busyIndicator.close();
          }
      } else if (data?.type === 'select_ingest_farm' && data.guid) {
        // Fired after an Ingest Config import/paste that carried its own selected farm —
        // switch the Data Connector dropdown to that farm, same as if the Analyst had picked it.
        const target = this.dataTransformConfigViewModel.ingestConfigs.find(i => i.guid === data.guid);
        if (target && target !== this.viewModel.selectedIngestConfig) {
          this.viewModel.selectedIngestConfig = target;
          this.onIngestConfigChanged(null);
        }
      } else if (data?.type === 'open_mapper_panel' && data.guid) {
        // Fired when the Data Connector's file/table/query changed and its Column Map was
        // cleared as a result — expand the Column Mapper panel so the Analyst sees right away
        // that it needs to be reconfigured, without waiting for a failed Save & Ingest Data.
        const target = this.dataTransformConfigViewModel.ingestConfigs.find(i => i.guid === data.guid);
        if (target) {
          if (target !== this.viewModel.selectedIngestConfig) {
            this.viewModel.selectedIngestConfig = target;
            this.onIngestConfigChanged(null);
          }
          this.mapperStepPanel?.open();
        }
      }
    });

    this.activeRoute.queryParams.subscribe(params => {
      if (params.activeFarmId) {
        const activeFarmId = params.activeFarmId;
        //console.log('activeFarmId in INGEST = ', activeFarmId);

        if (activeFarmId) {
          this.viewModel.selectedIngestConfig = this.dataTransformConfigViewModel.ingestConfigs.find(i => i.guid === activeFarmId);
          
          // ensure the ingest tab is activated
          this.configWorkflowStepper.selectedIndex = 0;

          if (this.viewModel.selectedIngestConfig.targetDataFarm == null) {
            this.viewModel.selectedIngestConfig.targetDataFarm = this.getDefaultDataFarmType();
          }

          this.onIngestConfigChanged(null);
        }
      }
    });

    this.userData.setSelectedIngestFarmGUID(this.dataTransformConfigViewModel.selectedIngestFarmGuid) // Save the currently/previously selected ingest farm guid in the local storage. 
    this.userData.setIngestId(this.dataTransformConfigViewModel.selectedIngestFarmGuid);
    if(this.dataTransformConfigViewModel.selectedIngestFarmGuid){
      this.viewModel.selectedIngestConfig = this.dataTransformConfigViewModel.ingestConfigs.find(i => i.guid === this.dataTransformConfigViewModel.selectedIngestFarmGuid);
    }


    this.viewModel.dataTransformConfigViewModel = this.dataTransformConfigViewModel;

    this.configVmSub = this.configViewModelService.configViewModel$.subscribe(this.configViewModelObserver);
    
    if (this.dataTransformConfigViewModel.ingestConfigs.length === 0) {
      // const ingestConfig = new DataConnectorMapping(0, 'Default', DataFarmType.subTask);
          //console.log('import selectedDataSourceType', this.selectedDataSourceType);
      const configJsonObject = this.userData.getSelectedConfigJson(); //state.config;
      // console.log('Ingest work flow configJsonObject', configJsonObject);

      // if(configJsonObject){
      //   var currentSavedIngestConfig = configJsonObject.dataConnectorMappings.filter( item => item.guid === this.dataTransformConfigViewModel.ingestConfigs?.guid)[0];
      // }

      const ingestConfig = new DataConnectorMapping(0, 'Default', this.getDefaultDataFarmType());
      const ingestConfigVM = new IngestConfigViewModel(ingestConfig, [], [], configJsonObject);
      this.viewModel.selectedIngestConfig = ingestConfigVM;
      this.viewModel.addIngestConfig(ingestConfigVM);
      this.viewModel.dataTransformConfigViewModel.featherDataConnectorViewModel = new FeatherDataConnectorViewModel();
      this.viewModel.dataTransformConfigViewModel.parquetDataConnectorViewModel = new ParquetDataConnectorViewModel();
      this.viewModel.dataTransformConfigViewModel.excelDataConnectorViewModel = new ExcelDataConnectorViewModel();
      this.viewModel.dataTransformConfigViewModel.fileDataConnectorViewModel = new FileDataConnectorViewModel();
      this.viewModel.dataTransformConfigViewModel.featherDataConnectorViewModel = new FeatherDataConnectorViewModel();
       this.viewModel.dataTransformConfigViewModel.databaseDataConnectorViewModel = new DatabaseDataConnectorViewModel();
      this.viewModel.dataTransformConfigViewModel.oracleDataConnectorViewModel = new OracleDataConnectorViewModel();
      this.viewModel.dataTransformConfigViewModel.mySqlDataConnectorViewModel = new MySqlDataConnectorViewModel();
      this.viewModel.dataTransformConfigViewModel.verticaDataConnectorViewModel = new VerticaDataConnectorViewModel();
      this.viewModel.dataTransformConfigViewModel.DataTypeConverter = new DataTypeConverter(0, 0, true, false);
      this.viewModel.dataTransformConfigViewModel.DeduplicateRows = new DeduplicateRows(0, false,0);
      this.viewModel.dataTransformConfigViewModel.DurationBuilder = new DurationBuilder(0, 0, '', '', '', false);//, []
      this.viewModel.dataTransformConfigViewModel.GeneralParameter = new GeneralParameter(0, 0, '', '', 'False', '', '', '0', '');
      this.viewModel.canSyncColumnsToMaster = false;

      // Notify config changed
      this.configViewModelService.setDataTransformConfigViewModel(this.dataTransformConfigViewModel);
    } else {
      // Apply default if none selected
      if (!this.viewModel.selectedIngestConfig) {
          this.viewModel.selectedIngestConfig = this.dataTransformConfigViewModel.ingestConfigs[0];
      }

      this.viewModel.updateMasterMappings();
    }
    
    if (this.viewModel.selectedIngestConfig.targetDataFarm == null) {
      this.viewModel.selectedIngestConfig.targetDataFarm = this.getDefaultDataFarmType();
    }
    // this.viewModel.selectedIngestConfig.targetDataFarm = 3 ;


    //this.onTargetDataFarmChanged(this.viewModel.selectedIngestConfig.targetDataFarm, null);
  }
  ngOnDestroy() {
    this.subscription.unsubscribe(); // Clean up to avoid memory leaks
    this.configVmSub?.unsubscribe();
    window.removeEventListener('beforeunload', this.onBeforeUnload);
  }
  ngAfterContentInit(): void {
    this.eventBroker.sendEvent(new SelectedIngestFarmChangedEvent(this.viewModel.selectedIngestConfig.guid));
  }

  getDefaultDataFarmType():any {
    //alert(history.state.dataSourceType);
    switch (history.state.dataSourceType) {
      case DataSourceType.behaviorData:
        return DataFarmType.behaviors;
      case DataSourceType.caseData:
        return DataFarmType.cases;
      case DataSourceType.userData:
        return DataFarmType.users;
      case DataSourceType.timeStampedData:
        return DataFarmType.subTask;
      case DataSourceType.activityData:
        return DataFarmType.activity;
      case DataSourceType.taskData:
        return DataFarmType.task;
      case DataSourceType.subtaskData:
        return DataFarmType.subTask;
      case DataSourceType.masterData:
        return DataFarmType.master;
                }
  }

  configureDataFarmTypes(): void {
    switch (history.state.dataSourceType) {
      case DataSourceType.behaviorData:
        this.viewModel.dataFarmTypes = [DataFarmType.behaviors];
        break;
      case DataSourceType.caseData:
        this.viewModel.dataFarmTypes = [DataFarmType.cases];
        break;
      case DataSourceType.userData:
        this.viewModel.dataFarmTypes = [DataFarmType.users];
        break;
      case DataSourceType.activityData:
        this.viewModel.dataFarmTypes = [DataFarmType.activity];
        break;
      case DataSourceType.taskData:
        this.viewModel.dataFarmTypes = [DataFarmType.task];
        break;
      case DataSourceType.subtaskData:
        this.viewModel.dataFarmTypes = [DataFarmType.subTask];
        break;
      case DataSourceType.timeStampedData:
        this.viewModel.dataFarmTypes = [DataFarmType.subTask, DataFarmType.task];
        break;
         case DataSourceType.masterData:
        this.viewModel.dataFarmTypes = [DataFarmType.master];
        break;
    }
  }

  async loadColumns(typeOfLoad?:string): Promise<void> {
    this.viewModel.loadColumnsFailed=false;
    // if (this.viewModel.selectedIngestConfig.hasColumns()) {
    //   //console.log(`not loading columns again, selected ingest config already has them: ${this.viewModel.selectedIngestConfig}`);
    //   return;
    // }

    // console.log('loading columns...');
    //console.log(this.viewModel);
    // console.log('dataConnectorType = ', this.viewModel.dataTransformConfigViewModel.dataConnectorType);
    var current_dataConnectorType = this.viewModel.dataTransformConfigViewModel.dataConnectorType ;
    const configJsonObject = this.userData.getSelectedConfigJson(); //state.config;
    if(configJsonObject){
      var previousConfig = configJsonObject.dataConnectorMappings.filter( item => item.guid === this.viewModel.selectedIngestConfig.guid)[0];
      if(previousConfig == undefined) {
        let ingestConfigsSize = configJsonObject.dataConnectorMappings.length
        let ingestConfigColMap = configJsonObject.dataConnectorMappings[ingestConfigsSize - 1].columnMap
        ingestConfigColMap.forEach(col => {
          let configMappedCol = new ConfigColumnMap(col.sourceColumn, col.targetColumn);
          this.configMappedCols.push(configMappedCol);
        });
      }
    }

    if(!this.viewModel.dataTransformConfigViewModel.dataConnectorType){

      // console.log(this.viewModel.dataTransformConfigViewModel);
      // console.log('Selected Ingest Config = ', this.viewModel.selectedIngestConfig);
      // this.viewModel.selectedIngestConfig.dataConnectorMappings
      var previousConfig = configJsonObject.dataConnectorMappings.filter (i => i.guid === this.viewModel.selectedIngestConfig.guid)[0];
      // Commented to map column everytime.
      // if(previousConfig.dataConnector['filePath'] != this.viewModel.selectedIngestConfig.dataConnector['inputFileName']){

        current_dataConnectorType = this.viewModel.selectedIngestConfig.dataConnector['dataConnectorType']
        
      // }
        previousConfig.columnMap.forEach(col => {
          let configMappedCol = new ConfigColumnMap(col.sourceColumn, col.targetColumn);
          let index = this.configMappedCols.findIndex(configmappedcol => configmappedcol.sourceColumnName == col.sourceColumn);
          if(index < 0) {
            this.configMappedCols.push(configMappedCol);
          } else {
            this.configMappedCols[index] = configMappedCol;
          }
           
        });
      
        // this.viewModel.selectedIngestConfig.columnMap.forEach(col => {
        //   let configMappedCol = new ConfigColumnMap(col.columnName, col.targetColumnName);
        //   this.configMappedCols.push(configMappedCol);    
        // });
    }

    console.log('dataConnectorType selectedIngestConfig = ', this.viewModel.selectedIngestConfig);
    //console.log('LINE-564 current_dataConnectorType = ', current_dataConnectorType);
    //console.log('dataConnectorType selectedIngestConfig = ', this.viewModel.selectedIngestConfig.dataConnector.isConnectionValid);
    
    // if(!savedIngestConfig){
      switch (current_dataConnectorType) {
        case DataConnectorType.Database:
          if(this.viewModel.selectedIngestConfig.databaseType===DatabaseType.SQL){
            await this.loadDatabaseColumns(this.viewModel.selectedIngestConfig.getDatabaseConnector(), this.configMappedCols, typeOfLoad);
          }else if(this.viewModel.selectedIngestConfig.databaseType===DatabaseType.Oracle){
            await this.loadOracleColumns(this.viewModel.selectedIngestConfig.getOracleConnector(), this.configMappedCols, typeOfLoad);
          
        }else if(this.viewModel.selectedIngestConfig.databaseType===DatabaseType.Vertica){
          await this.loadVerticaColumns(this.viewModel.selectedIngestConfig.getVerticaConnector(), this.configMappedCols, typeOfLoad);
        }
          else if(this.viewModel.selectedIngestConfig.databaseType===DatabaseType.MySql){
            await this.loadMySqlColumns(this.viewModel.selectedIngestConfig.getMySqlConnector(), this.configMappedCols, typeOfLoad);
          }
          break;
        case DataConnectorType.Text:
          await this.loadFileColumns(this.viewModel.selectedIngestConfig.getFileDataConnector(), this.configMappedCols, typeOfLoad);
          break;
        case DataConnectorType.Excel:
          await this.loadExcelColumns(this.viewModel.selectedIngestConfig.getExcelDataConnector(), this.configMappedCols, typeOfLoad);
          break;
        case DataConnectorType.Feather:
          await this.loadFeatherColumns(this.viewModel.selectedIngestConfig.getFeatherDataConnector(), this.configMappedCols, typeOfLoad);
          break;
         case DataConnectorType.Parquet:
          await this.loadParaquetColumns(this.viewModel.selectedIngestConfig.getParquetDataConnector(), this.configMappedCols, typeOfLoad);
          break;
      }

      this.viewModel.updateMasterMappings();
    // }
  }

  async loadDatabaseColumns(dbConnectorInfoViewModel: DatabaseDataConnectorViewModel, configMappedCols: ConfigColumnMap[], typeOfLoad?:string): Promise<void> {
    const organizationId = Number(this.userData.getOrgId());
    //console.log('loading columns for db: ' + dbConnectorInfoViewModel.databaseName);
    if(this.currentPlaceholdrCols.length > 0 && this.isClearMapButtonClicked == false) {
      configMappedCols.push(... this.currentPlaceholdrCols)
    }
    const columnMappings = (this.isClearMapButtonClicked) ? [] : configMappedCols; 
    const request = GetColumnsRequest.newDatabaseConnectorColumnRequest(
      dbConnectorInfoViewModel.toDataConnector() as DatabaseConnectorInfo,
      history.state.dataSourceType,
      organizationId, columnMappings, this.viewModel.selectedIngestConfig.targetDataFarm, this.isAutoMapApplied, this.isClearMapButtonClicked, this.ingestConfigGUID, "", "");
     
      if ( this.viewModel.selectedIngestConfig.dataConnector.isConnectionValid) {
        await this.loadColumnsInternal(request, typeOfLoad);
      } else {
        //this.showColumnMapperDBWarning();
        this.displayError(" Please check the connection.","Warning.");
      }
    //await this.loadColumnsInternal(request, typeOfLoad);
  }
  async loadOracleColumns(dbConnectorInfoViewModel: OracleDataConnectorViewModel, configMappedCols: ConfigColumnMap[], typeOfLoad?:string): Promise<void> {
    const organizationId = Number(this.userData.getOrgId());
    //console.log('loading columns for db: ' + dbConnectorInfoViewModel.databaseName);
    if(this.currentPlaceholdrCols.length > 0 && this.isClearMapButtonClicked == false) {
      configMappedCols.push(... this.currentPlaceholdrCols)
    }
    const columnMappings = (this.isClearMapButtonClicked) ? [] : configMappedCols; 
    const request = GetColumnsRequest.newOracleConnectorColumnRequest(
      dbConnectorInfoViewModel.toDataConnector() as OracleDataConnectorInfo,
      history.state.dataSourceType,
      organizationId, columnMappings, this.viewModel.selectedIngestConfig.targetDataFarm, this.isAutoMapApplied, this.isClearMapButtonClicked, this.ingestConfigGUID, "", "");
     
      if ( this.viewModel.selectedIngestConfig.dataConnector.isConnectionValid) {
        await this.loadColumnsInternal(request, typeOfLoad);
      } else {
      //  this.showColumnMapperDBWarning();
      this.displayError(" Please check the connection.","Warning.");

      }
    //await this.loadColumnsInternal(request, typeOfLoad);
  }
  async loadVerticaColumns(dbConnectorInfoViewModel: VerticaDataConnectorViewModel, configMappedCols: ConfigColumnMap[], typeOfLoad?:string): Promise<void> {
    const organizationId = Number(this.userData.getOrgId());
    //console.log('loading columns for db: ' + dbConnectorInfoViewModel.databaseName);
    if(this.currentPlaceholdrCols.length > 0 && this.isClearMapButtonClicked == false) {
      configMappedCols.push(... this.currentPlaceholdrCols)
    }
    const columnMappings = (this.isClearMapButtonClicked) ? [] : configMappedCols; 
    const request = GetColumnsRequest.newVerticaConnectorColumnRequest(
      dbConnectorInfoViewModel.toDataConnector() as VerticaDataConnectorInfo,
      history.state.dataSourceType,
      organizationId, columnMappings, this.viewModel.selectedIngestConfig.targetDataFarm, this.isAutoMapApplied, this.isClearMapButtonClicked, this.ingestConfigGUID, "", "");
     
      if ( this.viewModel.selectedIngestConfig.dataConnector.isConnectionValid) {
        await this.loadColumnsInternal(request, typeOfLoad);
      } else {
        //this.showColumnMapperDBWarning();
        this.displayError(" Please check the connection.","Warning.");
      }
    //await this.loadColumnsInternal(request, typeOfLoad);
  }
  async loadMySqlColumns(dbConnectorInfoViewModel: MySqlDataConnectorViewModel, configMappedCols: ConfigColumnMap[], typeOfLoad?:string): Promise<void> {
    const organizationId = Number(this.userData.getOrgId());
    //console.log('loading columns for db: ' + dbConnectorInfoViewModel.databaseName);
    if(this.currentPlaceholdrCols.length > 0 && this.isClearMapButtonClicked == false) {
      configMappedCols.push(... this.currentPlaceholdrCols)
    }
    const columnMappings = (this.isClearMapButtonClicked) ? [] : configMappedCols; 
    const request = GetColumnsRequest.newMySqlConnectorColumnRequest(
      dbConnectorInfoViewModel.toDataConnector() as MySqlDataConnectorInfo,
      history.state.dataSourceType,
      organizationId, columnMappings, this.viewModel.selectedIngestConfig.targetDataFarm, this.isAutoMapApplied, this.isClearMapButtonClicked, this.ingestConfigGUID, "", "");
     
      if ( this.viewModel.selectedIngestConfig.dataConnector.isConnectionValid) {
        await this.loadColumnsInternal(request, typeOfLoad);
      } else {
        //this.showColumnMapperDBWarning();
        this.displayError(" Please check the connection.","Warning.");
      }
    //await this.loadColumnsInternal(request, typeOfLoad);
  }
  async loadFileColumns(fileDataConnectorViewModel: FileDataConnectorViewModel, configMappedCols: ConfigColumnMap[], typeOfLoad?:string): Promise<void> {
    if (isFtpServiceMissing(fileDataConnectorViewModel.isUseFtp, fileDataConnectorViewModel.ftpService)) {
      this.displayError('Select an FTP service before loading columns.', 'Warning.');
      return;
    }
    const organizationId = Number(this.userData.getOrgId());
   // console.log(' loading columns for file: ' + fileDataConnectorViewModel.inputFileName);
   if(this.currentPlaceholdrCols.length > 0 && this.isClearMapButtonClicked == false) {
    configMappedCols.push(... this.currentPlaceholdrCols)
  }
    const columnMappings = (this.isClearMapButtonClicked) ? [] : configMappedCols; 
    const request = GetColumnsRequest.newFileConnectorColumnRequest(
      new FileDataConnectorInfo(
        fileDataConnectorViewModel.inputFileName,
        fileDataConnectorViewModel.fileNameFormat,
        fileDataConnectorViewModel.delimiter,
        fileDataConnectorViewModel.connectionTimeOut,fileDataConnectorViewModel.selectedInstance,fileDataConnectorViewModel.nValue,fileDataConnectorViewModel.isUseFtp,fileDataConnectorViewModel.ftpService),
        history.state.dataSourceType,
      organizationId, columnMappings, this.viewModel.selectedIngestConfig.targetDataFarm, this.isAutoMapApplied, this.isClearMapButtonClicked, this.ingestConfigGUID, "", "");

   // await this.loadColumnsInternal(request, typeOfLoad);
          if (fileDataConnectorViewModel.inputFileName) {
            await this.loadColumnsInternal(request, typeOfLoad);
          } else {
            //this.showColumnMapperWarning();
            this.displayError("  Developer file path is required for Column Mapper.","Warning.");
           
          }
  }
// Separate function for displaying the warning message

  async loadFeatherColumns(featherDataConnectorViewModel: FeatherDataConnectorViewModel, configMappedCols: ConfigColumnMap[], typeOfLoad?:string): Promise<void> {
    if (isFtpServiceMissing(featherDataConnectorViewModel.isUseFtp, featherDataConnectorViewModel.ftpService)) {
      this.displayError('Select an FTP service before loading columns.', 'Warning.');
      return;
    }
    const organizationId = Number(this.userData.getOrgId());
   // console.log(' loading columns for file: ' + featherDataConnectorViewModel.inputFileName);
   if(this.currentPlaceholdrCols.length > 0 && this.isClearMapButtonClicked == false) {
    configMappedCols.push(... this.currentPlaceholdrCols)
  }
    const columnMappings = (this.isClearMapButtonClicked) ? [] : configMappedCols; 
    const request = GetColumnsRequest.newFeatherConnectorColumnRequest(
      new FeatherDataConnectorInfo(
        featherDataConnectorViewModel.inputFileName,
        featherDataConnectorViewModel.fileNameFormat,
        featherDataConnectorViewModel.connectionTimeOut,featherDataConnectorViewModel.selectedInstance,featherDataConnectorViewModel.nValue,featherDataConnectorViewModel.isUseFtp,featherDataConnectorViewModel.ftpService),
        history.state.dataSourceType,
      organizationId, columnMappings, this.viewModel.selectedIngestConfig.targetDataFarm, this.isAutoMapApplied, this.isClearMapButtonClicked, this.ingestConfigGUID, "", "");

      //  await this.loadColumnsInternal(request, typeOfLoad);
      if (featherDataConnectorViewModel.inputFileName) {
        await this.loadColumnsInternal(request, typeOfLoad);
      } else {
        this.displayError("  Developer file path is required for Column Mapper.","Warning.");
      }
  }
async loadParaquetColumns(parquetDataConnectorViewModel: ParquetDataConnectorViewModel, configMappedCols: ConfigColumnMap[], typeOfLoad?:string): Promise<void> {
    if (isFtpServiceMissing(parquetDataConnectorViewModel.isUseFtp, parquetDataConnectorViewModel.ftpService)) {
      this.displayError('Select an FTP service before loading columns.', 'Warning.');
      return;
    }
    const organizationId = Number(this.userData.getOrgId());
    if (parquetDataConnectorViewModel.isPartitionMode && parquetDataConnectorViewModel.inputFileName === undefined) {
      parquetDataConnectorViewModel.inputFileName = "";
    }
    console.log(' loading columns for file: ' + parquetDataConnectorViewModel.inputFileName);
   if(this.currentPlaceholdrCols.length > 0 && this.isClearMapButtonClicked == false) {
    configMappedCols.push(... this.currentPlaceholdrCols)
  }
    const columnMappings = (this.isClearMapButtonClicked) ? [] : configMappedCols; 
    const request = GetColumnsRequest.newParaquetConnectorColumnRequest(
      new ParaquetDataConnectorInfo(
        parquetDataConnectorViewModel.inputFileName == undefined ? "" : parquetDataConnectorViewModel.inputFileName,
        parquetDataConnectorViewModel.fileNameFormat,
        parquetDataConnectorViewModel.connectionTimeOut,parquetDataConnectorViewModel.selectedInstance,parquetDataConnectorViewModel.nValue,parquetDataConnectorViewModel.inputFileNameFileScheduleDirectory,parquetDataConnectorViewModel.baseFileName,parquetDataConnectorViewModel.isUseFtp,parquetDataConnectorViewModel.ftpService,parquetDataConnectorViewModel.isPartitionMode,parquetDataConnectorViewModel.partitionDirectory),
        history.state.dataSourceType,
      organizationId, columnMappings, this.viewModel.selectedIngestConfig.targetDataFarm, this.isAutoMapApplied, this.isClearMapButtonClicked, this.ingestConfigGUID, "", "");

      const hasSource = parquetDataConnectorViewModel.isPartitionMode
        ? !!parquetDataConnectorViewModel.partitionDirectory
        : !!parquetDataConnectorViewModel.inputFileName;

      if (hasSource) {
        await this.loadColumnsInternal(request, typeOfLoad);
      } else {
        const msg = parquetDataConnectorViewModel.isPartitionMode
          ? 'Partition directory is required for Column Mapper.'
          : 'Developer file path is required for Column Mapper.';
        this.displayError(msg, 'Warning.');
      }
  }

  
  async loadExcelColumns(viewModel: ExcelDataConnectorViewModel, configMappedCols: ConfigColumnMap[], typeOfLoad?:string): Promise<void> {
    if (isFtpServiceMissing(viewModel.isUseFtp, viewModel.ftpService)) {
      this.displayError('Select an FTP service before loading columns.', 'Warning.');
      return;
    }
    const organizationId = Number(this.userData.getOrgId());
    //console.log('loading columns for file: ' + viewModel.inputFileName);
    if(this.currentPlaceholdrCols.length > 0 && this.isClearMapButtonClicked == false) {
      configMappedCols.push(... this.currentPlaceholdrCols)
    }
    const columnMappings = (this.isClearMapButtonClicked) ? [] : configMappedCols; 
    const request = GetColumnsRequest.newExcelConnectorColumnRequest(
      new ExcelDataConnector(0,
        viewModel.inputFileNameExcel,
        viewModel.fileNameFormatExcel,
        viewModel.sheetName,
        viewModel.sheets,
        viewModel.connectionTimeOut,viewModel.selectedInstance,viewModel.nValue,viewModel.isUseFtp,viewModel.ftpService),
        history.state.dataSourceType,
      organizationId, this.viewModel.selectedIngestConfig.excelTurboMode, this.viewModel.selectedIngestConfig.isMultiTabIngest, columnMappings, this.viewModel.selectedIngestConfig.targetDataFarm, this.isAutoMapApplied, this.isClearMapButtonClicked, this.ingestConfigGUID,"", "");

    //await this.loadColumnsInternal(request, typeOfLoad);
    if (viewModel.inputFileNameExcel) {
      await this.loadColumnsInternal(request, typeOfLoad);
    } else {
      this.displayError("  Developer file path is required for Column Mapper.","Warning.");
     
    }
  }

  async onIngestConfigChanged(event: any): Promise<void> {
    // An Ingest Farm can arrive here without a targetDataFarm (e.g. one added via Import/Paste
    // Ingest Config, which doesn't know the destination's farm type at merge time). Every other
    // creation path (onAddNewIngestFarm, ngOnInit) sets this immediately, and refreshLayout()'s
    // switch on targetDataFarm has no null case, so leaving it unset crashes as soon as the
    // Column Mapper panel is opened for this farm.
    if (this.viewModel.selectedIngestConfig.targetDataFarm == null) {
      this.viewModel.selectedIngestConfig.targetDataFarm = this.getDefaultDataFarmType();
    }
    this.showPlaceholderNotMappedWarning("mapper");
    this.lastSelectedIngest = this.viewModel.selectedIngestConfig;
    this.dataTransformConfigViewModel.selectedIngestFarmGuid = this.viewModel.selectedIngestConfig.guid

    this.configViewModelService.setDataTransformConfigViewModel(this.viewModel.dataTransformConfigViewModel);
    // Send the selected Ingest Farm GUID as a parameter to the sendEvent method, which is then received in the getEvent in the config-detail component.
    // Then the index of the selected ingest farm guid is obtained from the dataConnectorMappings.
    // After obtaining the index, it is used to update the dataConnectorMappings of the config with the Placeholder Column.
    this.userData.setSelectedIngestFarmGUID(this.viewModel.selectedIngestConfig.guid);
    this.userData.setIngestId(this.viewModel.selectedIngestConfig.guid);
    // const busyDialog = this.showBusyDialog('Loading Data Connector...');
    // try {
    //   await Promise.all([
    //     this.rawDataFarmPreviewTable.onRefreshClicked(),
    //     this.inputDataFarmPreviewTable.onRefreshClicked()
    //   ]);
    // } finally {
    //   busyDialog.close();
    // }
    // Switching the Data Connector no longer auto-loads the Raw/Input previews here — that
    // round trip was slow enough to make the dropdown feel unresponsive. Instead, clear all
    // three preview tables (data, sort, filter, row/column counts) for the newly selected
    // farm and let the Analyst pull fresh data with the Refresh Preview button when ready.
    this.clearAllIngestPreviews();

    this.viewModel.updateMasterMappings();
    this.eventBroker.sendEvent(new SelectedIngestFarmChangedEvent(this.viewModel.selectedIngestConfig.guid));
  }

  // Clears all three ingest previews (Raw/Input/Output) — data, sort, filter and
  // row/column counts. Used both when the Data Connector is switched and after a
  // Reset Node, so the previews reflect the now-empty node cache.
  clearAllIngestPreviews(): void {
    this.clearAllSortFilter();
    this.rawDataColumnsCount = 0;
    this.inputDataColumnsCount = 0;
    this.rawDataFarmPreviewTable.resetPreviewAndFilters();
    this.inputDataFarmPreviewTable.resetPreviewAndFilters();
    this.resetOutputPreview();
  }

  async loadColumnsInternal(request: GetColumnsRequest, typeOfLoad?:string): Promise<void> {
    try {
      this.viewModel.isLoadingColumns = true;
      if(request.ingestConfigGUID == "") {
        this.isAutoMapApplied = false;
      }
      if(this.selectedMapType) {
       if(this.selectedMapType == "all_maps" && this.isAutoMapApplied == false) {
            request.selectedIngestFarmGUID = "";
            request.mapLibraryType = this.selectedMapType;
            request.ingestConfigGUID = this.selectedIngestGUID;
            request.isAutoMapApplied = false;
      } else {
            request.selectedIngestFarmGUID =  (this.selectedIngestGUID !== undefined) ? this.selectedIngestGUID : "";
            request.mapLibraryType = this.selectedMapType;
            if(this.isAutoMapApplied) {
              if(request.ingestConfigGUID == "") {
                request.ingestConfigGUID = this.userData.getSelectedConfigJson().guid
              }
            }
            
      }
    }
      //const columns = await this.configService.loadColumns(request);
      const columns = await this.configService.loadColumnsV2(request);
      //this.viewModel.hasColumns = columns.length > 0;

      this.columnDefinitions = columns;

      this.previewDataViewModel = this.viewModel.dataTransformConfigViewModel.toImportDataViewModel();
      this.viewModel.selectedIngestConfig.columnMap = columns.map(input => {
        var id = 0;
        var showPlaceholderDelBtn = false;
        if(input.columnName.match("Placeholder")) {
           var columnnamearry = input.columnName.split("_");
           id = Number(columnnamearry[1]);
           showPlaceholderDelBtn = true;
        } else {
           id = 0;
           showPlaceholderDelBtn = false;
        }
        
       // return new ColumnMapDefinitionModel(id, input.index, input.columnName, '', '', '', showPlaceholderDelBtn);
        return new ColumnMapDefinitionModel(id, input.index, input.columnName, input.dataType, input.pyDataType, input.description, showPlaceholderDelBtn, input.targetColumnName);
      });
      this.previewDataViewModel.columns = this.viewModel.selectedIngestConfig.columnMap;
      //this.viewModel.hasColumns = this.previewDataViewModel.columns.length > 0;
      if(this.isAutoMapApplied) {
        this.displayInfo("Auto-mapping has been applied", "Auto Mapping Alert");
      } 
      // else if(this.isAutoMapApplied == false && this.isClearMapButtonClicked == false) {
      //    const isAllTargetColumnNotMapped = this.previewDataViewModel.columns.every(item => !item.targetColumnName || item.targetColumnName.trim() === "");
      //    if(isAllTargetColumnNotMapped) {
      //     this.displayInfo("There are no column maps that match these input column names", "Recalled Map");
      //    } else {
      //      const isSomeTargetColumnNotMapped = this.previewDataViewModel.columns.some(item => {
      //           const value = item.targetColumnName;
      //           return value == null || value.trim() === "";
      //      });
      //      if(isSomeTargetColumnNotMapped) {
      //         let mappedCount = 0;
      //         let totalColumnsCount = this.previewDataViewModel.columns.length;

      //         this.previewDataViewModel.columns.forEach(item => {
      //           const value = item.targetColumnName;

      //           if (value != null && value.trim() !== "") {
      //             mappedCount++;
      //           } 
      //         });
      //         this.displayInfo("A column map was found that matches " + mappedCount + " of" + totalColumnsCount + " columns", "Recalled Map");
      //      }  
      //    }
      // }
      this.mapperLayout.refreshLayout(typeOfLoad);
    } catch (err) {
      alert(err.message);
      this.viewModel.loadColumnsFailed = true;
      this.viewModel.lastErrorMessage = 'Failed to load columns';
      // this.displayError(`Failed to load columns`, 'Error', err);
    } finally {
      this.viewModel.isLoadingColumns = false;
    }
  }

  async onPanelOpened(panel: string, isLoadConnectorColumnsClicked?: boolean, onMatchToPreviousMappingClicked?: boolean):  Promise<void> {
    if(panel == "preview") {
      if(this.selectedIndex == 0) {
        this.userData.setRawTabClicked(true);
      }
    }

    this.fileExists = true;
    this.input_File_Path = '';
    this.input_File_Separate = '';
    if(this.viewModel.selectedIngestConfig?.dataConnector?.dataConnectorType == 4 ){
      this.input_File_Path = this.viewModel.selectedIngestConfig?.dataConnector?.inputFileNameExcel;
      this.input_File_Separate = this.viewModel.selectedIngestConfig?.dataConnector?.sheetName ;
    }
    if(this.viewModel.selectedIngestConfig?.dataConnector?.dataConnectorType == 3 ){
      this.input_File_Path = this.viewModel.selectedIngestConfig?.dataConnector?.inputFileName;
      this.input_File_Separate = this.viewModel.selectedIngestConfig?.dataConnector?.delimiter ;
    }

    // console.log('Parsu.IN event.selectedIndex === input_File_Path', this.input_File_Path);
    
    if(!this.input_File_Path || this.input_File_Separate == ''){
      this.fileExists = false;
    }
    const configJsonObject = this.userData.getSelectedConfigJson(); //state.config;
    //  console.log('configJsonObject', configJsonObject)
    if(configJsonObject){
      var savedIngestConfig = configJsonObject.dataConnectorMappings[0];//.filter( item => item.guid === this.viewModel.selectedIngestConfig.guid)[0];
    }

  // console.log('loading Data Connector Chanhe steps...');
     if (panel === "connector") {
      this.changeDet.detectChanges();
      console.log('Parsu.IN event.selectedIndex === 0');
      
      if(this.fileExists){
        this.saveIngest.emit(this.userData.getSelectedNodeDetails().name);
      }
    }
    // Automatically load the columns when we select Map Columns Step
    else if (panel === "mapper") {
      if(isLoadConnectorColumnsClicked) {
        this.isAutoMapApplied = false;
        this.isLoadConnectorColumnsClicked = true;
      } else if(onMatchToPreviousMappingClicked) {
        this.isAutoMapApplied = false;
        this.isLoadConnectorColumnsClicked = false;
      } else {
        this.isLoadConnectorColumnsClicked = false;
        this.isAutoMapApplied = true;
      }
      
      this.changeDet.detectChanges();

      // if(this.viewModel.selectedIngestConfig?.dataConnector?.dataConnectorType == 4 && this.viewModel.selectedIngestConfig?.dataConnector?.sheetName == ''){
      //   this.fileExists = false;
      // }
      // if(this.viewModel.selectedIngestConfig?.dataConnector?.dataConnectorType == 3 && this.viewModel.selectedIngestConfig?.dataConnector?.delimiter == ''){
      //   this.fileExists = false;
      // }
      // if(!this.fileExists)
      // {
      //   console.log(` is not a file.`);
      //   this.stepperVertical.selectedIndex = 0;
      //   return
      // }

       this.onTargetDataFarmChanged(this.viewModel.selectedIngestConfig.targetDataFarm, null)
      // await this.loadColumns();
      // var confirmTitle = '' ;
      // var confirmmessage = '' ;

      // // console.log('loading Data Connector selectedIngestConfig.', this.viewModel.selectedIngestConfig);
      //   if(savedIngestConfig?.dataConnector?.filePath && this.input_File_Path != savedIngestConfig?.dataConnector?.filePath ){
      //     if(!this.viewModel.selectedIngestConfig.matchAllColumns ){
      //        confirmTitle = 'No Match.' ;
      //        confirmmessage = 'None of the fields that were mapped in the previous Ingest farm in the current Ingest farm, therefore there are no mapped fields.' ;
      //     }else if(this.viewModel.selectedIngestConfig.notMatchingColumns.length > 0){
      //       let commaSeparatedString: string = this.viewModel.selectedIngestConfig.notMatchingColumns.join(', ');
      //       // this.displayInfo(`The following fields (${commaSeparatedString}) were mapped in the previous ingest farm and are in the current ingest farm.`,'Partial Match ')
      //        confirmTitle = 'Partial Match.' ;
      //        confirmmessage = `The following fields (${commaSeparatedString}) were mapped in the previous ingest farm and are in the current ingest farm.` ;
      //     }
      //     if(confirmTitle != '' && confirmmessage!= ''){
      //       this.showConfirmDialog(confirmTitle, confirmmessage, async (confirmed) => {
      //         if (confirmed) {
      //           this.saveIngest.emit(this.userData.getSelectedNodeDetails().name);
      //         }
      //         else{
      //           await this.loadColumns('Previous');

      //         }
      //       });
      //     }
      //   }
    } 
    // Automatically refresh preview the data when we select Preview step
    else if (panel === "preview") {
      
      // this.saveIngest.emit(this.userData.getSelectedNodeDetails().name);
      // // // console.log('Biswa.IN event.selectedIndex === 2');
      //  const busyIndicator = this.showBusyDialog('Loading Data...');
      // // // console.log('Biswa.IN event.selectedIndex === 22');
      //  //await this.previewTable.onRefreshClicked();
      //  await this.rawDataFarmPreviewTable.onRefreshClicked();
      //  this.checkIfMappedColsExistsInvkInputPrevw();
      // // // console.log('Biswa.IN event.selectedIndex === 222');
       
      // // // console.log('Biswa.IN event.selectedIndex === 2222');
      //  busyIndicator.close();
      // // // console.log('Biswa.IN event.selectedIndex === 22222');

    }
    else if (panel === "") {
      
    }

    // this.saveIngest.emit(this.userData.getSelectedNodeDetails().name);
  }

  onDataConnectorStateChanged(state: DataTransformConfigViewModel): void {
    this.dataConnectorStateChanged.emit(state);

    if (state.dataConnectorType === DataConnectorType.Text) {
      if (this.viewModel.selectedIngestConfig.dataConnectorType !== state.dataConnectorType) {
        this.viewModel.selectedIngestConfig.dataConnectorType = state.dataConnectorType;
        this.viewModel.selectedIngestConfig.dataConnector = new FileDataConnectorViewModel();
      }
    } else if (state.dataConnectorType === DataConnectorType.Excel) {
      if (this.viewModel.selectedIngestConfig.dataConnectorType !== state.dataConnectorType) {
        this.viewModel.selectedIngestConfig.dataConnectorType = state.dataConnectorType;
        this.viewModel.selectedIngestConfig.dataConnector = new ExcelDataConnectorViewModel();
      }
    }
    else if (state.dataConnectorType === DataConnectorType.Database) {
      if (this.viewModel.selectedIngestConfig.dataConnectorType !== state.dataConnectorType) {
        this.viewModel.selectedIngestConfig.dataConnectorType = state.dataConnectorType;
        if (this.viewModel.selectedIngestConfig.databaseType==DatabaseType.SQL){
          this.viewModel.selectedIngestConfig.dataConnector = new DatabaseDataConnectorViewModel();
        }else if (this.viewModel.selectedIngestConfig.databaseType==DatabaseType.Oracle){
          this.viewModel.selectedIngestConfig.dataConnector = new OracleDataConnectorViewModel();
        }
        else if (this.viewModel.selectedIngestConfig.databaseType==DatabaseType.Vertica){
          this.viewModel.selectedIngestConfig.dataConnector = new VerticaDataConnectorViewModel();
        }
        else if (this.viewModel.selectedIngestConfig.databaseType==DatabaseType.MySql){
          this.viewModel.selectedIngestConfig.dataConnector = new MySqlDataConnectorViewModel();
        }
      }
    }
    else if (state.dataConnectorType === DataConnectorType.Feather) {
      if (this.viewModel.selectedIngestConfig.dataConnectorType !== state.dataConnectorType) {
        this.viewModel.selectedIngestConfig.dataConnectorType = state.dataConnectorType;
        this.viewModel.selectedIngestConfig.dataConnector = new FeatherDataConnectorViewModel();
      }
    }
     else if (state.dataConnectorType === DataConnectorType.Parquet) {
      if (this.viewModel.selectedIngestConfig.dataConnectorType !== state.dataConnectorType) {
        this.viewModel.selectedIngestConfig.dataConnectorType = state.dataConnectorType;
        this.viewModel.selectedIngestConfig.dataConnector = new ParquetDataConnectorViewModel();
      }
    }
    if (state.isDataValid) {

    }
    // this.sharedService.sendEvent("mapper_updated");
  }

  delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async onStepCompleted(complete: boolean): Promise<void> {
    if (complete) {
      this.configWorkflowStep.isComplete = true;
      await this.delay(500);
      this.configWorkflowStepper.next();
    }
  }

  onAddNewIngestFarm(): void {
    
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '400px';
    dialogConfig.data = {title: 'New Ingest Farm', placeholder: 'Enter name for Ingest Farm'};

    const dialogRef = this.matDialog.open(NewSingleStringValueDialogComponent, dialogConfig);
    const configJsonObject = this.userData.getSelectedConfigJson(); //state.config;
    // console

    dialogRef.afterClosed().subscribe(result => {
      if (!result.stringValue) { return; }      
      this.showPlaceholderNotMappedWarning("mapper");
      const dataConnectorMapping = new DataConnectorMapping(0, result.stringValue, this.getDefaultDataFarmType());
      const ingestConfigVM = new IngestConfigViewModel(dataConnectorMapping, [], [], configJsonObject);
      this.viewModel.addIngestConfig(ingestConfigVM);
      this.viewModel.selectedIngestConfig = ingestConfigVM;

      // console.log('onDeleteIngestFarm 819 ingestConfigVM: ',  ingestConfigVM )

      this.viewModel.selectedIngestFarmGuid = ingestConfigVM.guid;
      this.dataTransformConfigViewModel.selectedIngestFarmGuid = ingestConfigVM.guid;
      // Notify config changed
      this.configViewModelService.setDataTransformConfigViewModel(this.dataTransformConfigViewModel);
      this.userData.setSelectedIngestFarmGUID(this.dataTransformConfigViewModel.selectedIngestFarmGuid);
      // Update the Ingest Node status to Not Run if it is in Completed Status.
      // this.updateingestnodestatusService.invokeUpdateIngestNodeStatus();
      //this.viewModel.hasColumns = false;
      // Reset each step to incomplete selectedIngestFarmGuid

      this.viewModel.steps.forEach( s => s.isComplete = false );
      // Select the first
      this.stepperVertical.selectedIndex = 0;
      // this.saveIngest.emit(this.userData.getSelectedNodeDetails().name);
    });  
    // this.sharedService.sendEvent("mapper_updated");
  }

  onEditIngestFarm(ingestConfig: IngestConfigViewModel): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '400px';
    dialogConfig.data = {stringValue: ingestConfig.name, title: 'Edit Ingest Farm', placeholder: 'Enter name for Ingest Farm'};

    const dialogRef = this.matDialog.open(NewSingleStringValueDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result.stringValue) { return; }
      ingestConfig.name = result.stringValue;
      this.saveIngest.emit(this.userData.getSelectedNodeDetails().name);
    });
  }

  // onDeleteIngestFarm(ingestConfig: IngestConfigViewModel): void {
  //   this.showConfirmDialog('Delete Confirmation', `Are you sure you want to delete prajna11 \"${ingestConfig.name}\" Ingest Farm?`, (confirmed) => {
  //     if (confirmed) {
  //       const index = this.viewModel.dataTransformConfigViewModel.ingestConfigs.indexOf(ingestConfig);
  //       this.viewModel.dataTransformConfigViewModel.ingestConfigs.splice(index, 1);
  //       if ( this.viewModel.dataTransformConfigViewModel.ingestConfigs.length > 0 ) {
  //         const lastIndex = this.viewModel.dataTransformConfigViewModel.ingestConfigs.length - 1;
  //         this.viewModel.selectedIngestConfig = this.viewModel.dataTransformConfigViewModel.ingestConfigs[lastIndex];
  //         this.viewModel.selectedIngestFarmGuid = this.viewModel.dataTransformConfigViewModel.ingestConfigs[lastIndex].guid;
  //         this.dataTransformConfigViewModel.selectedIngestFarmGuid = this.viewModel.dataTransformConfigViewModel.ingestConfigs[lastIndex].guid;

  //         // console.log('onDeleteIngestFarm 857 ingestConfigs: ',  this.viewModel.dataTransformConfigViewModel.ingestConfigs[lastIndex].guid )
  //       }
  //       else {
  //         this.viewModel.selectedIngestConfig = null;
  //       }

  //       this.viewModel.updateMasterMappings();
  //       // console.log('onDeleteIngestFarm 864 dataTransformConfigViewModel: ', this.dataTransformConfigViewModel)
  //       // Notify config changed
  //       this.configViewModelService.setDataTransformConfigViewModel(this.dataTransformConfigViewModel);
  //       this.saveIngest.emit(this.userData.getSelectedNodeDetails().name);
  //     }
  //   });
  // }
onDeleteIngestFarm(ingestConfig: IngestConfigViewModel): void {
  const configs = this.viewModel.dataTransformConfigViewModel.ingestConfigs;

  if (configs.length === 1) {
    // Only one farm left, cannot delete
    this.snackBar.open(
      '⚠️ Only one ingest farm exists. Cannot delete the last farm.',
      'Dismiss',
      { duration: 4000 }
    );
    return;
  }

  this.showConfirmDialog(
    'Delete Confirmation',
    `Are you sure you want to delete "${ingestConfig.name}" Ingest Farm?`,
    (confirmed) => {
      if (!confirmed) return;

      const index = configs.indexOf(ingestConfig);
      if (index >= 0) configs.splice(index, 1);

      // Pick new selected farm
      let newSelected: IngestConfigViewModel | null = null;
      if (configs.length > 0) {
        let newIndex: number;
        // if (index === 0) {
        //   newIndex = 0; // Deleted first → pick new first
        // } else if (index >= configs.length) {
        //   newIndex = configs.length - 1; // Deleted last → pick previous
        // } else {
        //   newIndex = index; // Deleted middle → pick next
        // }
        if (index === 0) {
          newIndex = configs.length - 1; // ✅ Deleted first → pick last
      } else if (index >= configs.length) {
          newIndex = configs.length - 1; // Deleted last → pick previous
      } else {
          newIndex = index; // Deleted middle → pick next
      }

        newSelected = configs[newIndex];
        this.viewModel.selectedIngestConfig = newSelected;
        this.viewModel.selectedIngestFarmGuid = newSelected.guid;
        this.dataTransformConfigViewModel.selectedIngestFarmGuid = newSelected.guid;

        // this.snackBar.open(
        //   `Ingest farm "${ingestConfig.name}" deleted. Selected farm is now "${newSelected.name}".`,
        //   'Dismiss',
        //   { duration: 4000 }
        // );
      }

      // Update master mappings and save
      this.viewModel.updateMasterMappings();
      this.configViewModelService.setDataTransformConfigViewModel(this.dataTransformConfigViewModel);
      this.saveIngest.emit(this.userData.getSelectedNodeDetails().name);

      console.log('✅ Deleted ingest farm:', ingestConfig.name);
      console.log('📊 Remaining farms:', configs.map(c => ({ name: c.name, guid: c.guid })));
    }
  );
}


// onDeleteIngestFarm(ingestConfig: IngestConfigViewModel): void {
//   this.showConfirmDialog(
//     'Delete Confirmation',
//     `Are you sure you want to delete "${ingestConfig.name}" Ingest Farm?`,
//     (confirmed) => {
//       if (!confirmed) return;

//       const configs = this.viewModel.dataTransformConfigViewModel.ingestConfigs;

//       console.group('🗑️ Delete Ingest Farm Debug');
//       console.log('👉 Farm requested for deletion:', ingestConfig);
//       console.log('📊 Farms BEFORE deletion:', configs.map(c => ({ name: c.name, guid: c.guid })));

//       const index = configs.findIndex(c => c.guid === ingestConfig.guid);
//       console.log('🔎 Found index of farm to delete (by GUID):', index);

//         if (index >= 0) {
//         configs.splice(index, 1);
//         console.log(`✅ Deleted farm "${ingestConfig.name}" (GUID: ${ingestConfig.guid})`);
//       } else {
//         console.warn('⚠️ Farm not found in configs list, nothing deleted!');
//       }

//       console.log('📊 Farms AFTER deletion:', configs.map(c => ({ name: c.name, guid: c.guid })));

//       // ✅ Update selected ingest config
//       if (configs.length > 0) {
//         const newSelected = configs[Math.min(index, configs.length - 1)];
//         this.viewModel.selectedIngestConfig = newSelected;
//         this.viewModel.selectedIngestFarmGuid = newSelected.guid;
//         console.log('🎯 New selected farm after deletion:', {
//           name: newSelected.name,
//           guid: newSelected.guid
//         });
//       } else {
//         this.viewModel.selectedIngestConfig = null;
//         this.viewModel.selectedIngestFarmGuid = null;
//         console.warn('⚠️ No farms left after deletion.');
//       }

//       // ✅ Update master mappings
//       console.log('🔄 Updating master mappings...');
//       this.viewModel.updateMasterMappings();

//       // ✅ Save directly using the existing object reference
//       console.log('💾 Saving remaining farms...');
//       console.log('🗂️ Full dataTransformConfigViewModel (BEFORE save):', this.viewModel.dataTransformConfigViewModel);
//       this.configViewModelService.setDataTransformConfigViewModel(this.viewModel.dataTransformConfigViewModel);
       
//       this.saveIngest.emit(this.userData.getSelectedNodeDetails().name);

//       // 👇 Check after save
//       console.log(
//         '📊 Farms AFTER save call:',
//         this.viewModel.dataTransformConfigViewModel.ingestConfigs
//           .map(c => ({ name: c.name, guid: c.guid }))
//       );

//       console.groupEnd();
//     }
//   );
// }



  onTargetDataFarmChanged(dataFarm: DataFarmType, event: any): void {
    //dataFarm = 3;
    if (this.viewModel.selectedIngestConfig) {
      this.viewModel.selectedIngestConfig.targetDataFarm = dataFarm;
    }

    // console.log('onTargetDataFarmChanged 816 dataFarm: ', this.viewModel.selectedIngestConfig.targetDataFarm)
    this.configureDataFarmTypes();
    // console.log('onTargetDataFarmChanged 818 dataFarm: ', this.mapperLayout)
    if(this.mapperLayout != null && this.mapperLayout != undefined){
       this.mapperLayout.refreshLayout();
    }
    // this.sharedService.sendEvent("mapper_updated");
    // console.log('onTargetDataFarmChanged 820 dataFarm: ', this.viewModel.selectedIngestConfig.targetDataFarm)
  }

  // Add Placeholder Fields Function to add Placeholder Fields as source field to the bootom of the Column Map Table.
  addPlaceholderFields() {
    // Fetch the list of placeholder columns if added by the analyst.
    var placeholderColsList = this.viewModel.selectedIngestConfig.columnMap.filter(colMap => colMap.columnName.match('Placeholder'))
    // Increment the id and assign it to the new variable to be used later.
    var placeholderColId = placeholderColsList.length + 1
    var colmapDefnModelIndex = this.viewModel.selectedIngestConfig.columnMap[this.viewModel.selectedIngestConfig.columnMap.length - 1].index;
    colmapDefnModelIndex += 1; 
    const newPlaceholderColumnRow = new ColumnMapDefinitionModel(placeholderColId, colmapDefnModelIndex, 'Placeholder_'+placeholderColId, '', '', '', true, "");
    console.log(newPlaceholderColumnRow);
    this.viewModel.selectedIngestConfig.columnMap.push(newPlaceholderColumnRow);
    // this.updateingestnodestatusService.invokeUpdateIngestNodeStatus();
    this.mapperLayout.refreshLayout();
  }

  // Show Warning box if there are any rows where the source column is not mapped to target column & this is applicable to Placeholder columns.
  showPlaceholderNotMappedWarning(panelType: string) {
    console.log(this.viewModel.selectedIngestConfig);
    const placeholderColsList = this.viewModel.selectedIngestConfig.columnMap.filter(colMap => (colMap.columnName.match("Placeholder") && (colMap.targetColumnName == undefined || colMap.targetColumnName.length == 0)))
    if(placeholderColsList.length > 0) {
      for(var i = 0; i < placeholderColsList.length; i++) {
        const index = this.viewModel.selectedIngestConfig.columnMap.findIndex(colMap => colMap.index === placeholderColsList[i].index);
        this.viewModel.selectedIngestConfig.columnMap.splice(index, 1);
     }
     if(panelType == "ingesttransform") {
      this.mapperLayout.refreshLayout();
     }
     this.displayWarning("Placeholder rows that are not mapped to an output field will not be included in the configuration", "Not Mapped Placeholder Rows")
    }
  }

  // Check and Enable  Delete button for rows having Placeholder Columns.
  checkAndEnableDeltebtnforPlaceholdrCols() {
    if(this.viewModel.selectedIngestConfig?.columnMap){
      this.viewModel.selectedIngestConfig.columnMap.map(colmap => {
        if(colmap.columnName.match("Placeholder")){
          colmap.showPlaceholderDelbtn = true;
        }
      });
    }
  }

  async refreshPreview() {
     const busyIndicator = this.showBusyDialog('Loading Data...');
     this.clearAllSortFilter();
     await this.refreshRawDataFarmPreviewAsync(this.rawDataFarmPreviewTable);
     this.outputDataColumnsCount = 0;
     this.outputDataFarmPreviewTable.resetPreview();
     this.checkIfMappedColsExistsInvkInputPrevw();
     busyIndicator.close();
  }

  async resetOutputPreview() {
    this.outputDataColumnsCount = 0;
    this.outputDataFarmPreviewTable.resetPreviewAndFilters();
  }
  
  async refreshRawDataFarmPreviewAsync(sender: PreviewTableComponent): Promise<void> {
    const filePath = this.viewModel.selectedIngestConfig?.dataConnector?.toDataConnector()?.filePath;
    const parquetPartitionDirectory = (this.viewModel.selectedIngestConfig?.dataConnectorType === DataConnectorType.Parquet) ? (this.viewModel.selectedIngestConfig?.dataConnector as ParquetDataConnectorViewModel)?.partitionDirectory : null;
    const connectorType = this.viewModel.selectedIngestConfig.dataConnectorType as DataConnectorType;
    if (connectorType === DataConnectorType.Database || filePath || parquetPartitionDirectory) {
      //const busyIndicator = this.showBusyDialog('Loading Data...');
      var blankRawDataPreview = new PreviewData();
      blankRawDataPreview.columns = [{id: 0, index: 0, columnName: '', dataType: '', pyDataType: '', targetColumnName: '', description: ''}]
      blankRawDataPreview.rows = {field : ""}
      blankRawDataPreview.totalRows = 0
      sender.bindData(blankRawDataPreview, 'No preview data');

      const state = history.state;

      sender.isGettingData.next(true);

      try {
        const colMap = [];
        const dataSourceType = this.dataTransformConfigViewModel.dataSourceType;
        let generalParameter = this.viewModel.dataTransformConfigViewModel.GeneralParameter;
        this.userData.setRawGeneralParams(generalParameter);
        if(this.viewModel.selectedIngestConfig.dataConnector){
          const dataConnectorMapping = new DataConnectorMapping(
            this.viewModel.selectedIngestConfig.id,
            this.viewModel.selectedIngestConfig.name,
            this.viewModel.selectedIngestConfig.targetDataFarm,
            this.viewModel.selectedIngestConfig.dataConnector.toDataConnector(),
            colMap,
            this.viewModel.selectedIngestConfig.guid,
            this.viewModel.selectedIngestConfig.masterColumnMapGuid,
            state.refineryConfigGuid,
            state.nodeId,
            state.nodename,
            state.nodeType,
            this.viewModel.selectedIngestConfig.isMultiTabIngest,
            this.viewModel.selectedIngestConfig.excelTurboMode,
            this.viewModel.selectedIngestConfig.ingestAll,
            this.viewModel.selectedIngestConfig.sampleStart,
            this.viewModel.selectedIngestConfig.sampleEnd,
          );
          this.userData.setRawdataconnectorMapping(dataConnectorMapping);
          this.userData.setIngestId(this.viewModel.selectedIngestConfig.guid);
          const filters = sender.activeFilterSet?.map(f => {
            const filterInfo = new ColumnFilter();
            filterInfo.field = f.columnName;
            filterInfo.values = f.values;
            return filterInfo;
          });
          const sortInfo = this.activeSortsSet;
          const options = new PreviewDataOptions(sender.pageIndex, sender.rowsPerPage, sortInfo,filters);

          const cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.ingestRaw);
          const request = new GetDataFarmPreviewIngestRequest(
            cachekeyRequest.userId,
            cachekeyRequest.orgId,
            cachekeyRequest.refineryId,
            cachekeyRequest.nodeId,
            cachekeyRequest.cacheKeyType,
            options,
            generalParameter,
            dataConnectorMapping);

          const response = await this.configService.getRawDataFarmPreviewAsync(request);
          if(response.data == null && response.errorMsg.length > 0) {
            // throw new Error(response.errorMsg); // triggers catch block
            this.hasAlreadyShownError = true;
          } else {
            this.rawDataColumnsCount = response.data.columns.length;
            this.checkAndEnableDeltebtnforPlaceholdrCols();
            sender.bindData(response.data, 'No preview data', response.selectedPartitionedColumn);
          }
        }
      } catch (err: any) {
        if (err.message?.includes('DataFrame is empty')) {
          this.displayError('The file is empty or was not found. Please check the feather file path.', 'Error.', err);
        } else if (err.message?.includes('NoneType')) {
          this.displayError('The file was not found or the path is invalid.', 'Error.', err);
        } else if (err.message?.includes('JSONDecodeError') || err.message?.includes('Expecting value')) {
          this.displayError(
            'The refinery configuration file could not be read — it may be empty or corrupted. Please verify the refinery configuration and try again.',
            'Error.', err);
        } else {
          this.displayError('Failed to get raw data farm preview', 'Error', err);
        }
      } finally {
            //busyIndicator.close();
            sender.isGettingData.next(false);
      }
    } else {
      if (this.viewModel.selectedIngestConfig.dataConnectorType !==  DataConnectorType.Database) {
      this.displayError("Developer file path is required for Data Preview.", "Warning");
      }
    }
  }
  async refreshOutputDataFarmPreviewAsync(sender: PreviewTableComponent): Promise<void> {
    //const busyIndicator = this.showBusyDialog('Loading Output Data...');
    var blankOutputDataPreview = new PreviewData();
    blankOutputDataPreview.columns = [{id: 0, index: 0, columnName: '', dataType: '', pyDataType: '', targetColumnName: '', description: ''}]
    blankOutputDataPreview.rows = {field : ""}
    blankOutputDataPreview.totalRows = 0
    sender.bindData(blankOutputDataPreview, 'No preview data');
    sender.isGettingData.next(true);
    try {
      if(this.viewModel.selectedIngestConfig.dataConnector){
        sender.activeFilterSet = (this.isClearSortFilterAfterIngestSaved) ? [] : sender.activeFilterSet;
        const filters = sender.activeFilterSet?.map(f => {
          const filterInfo = new ColumnFilter();
          filterInfo.field = f.columnName;
          filterInfo.values = f.values;
          return filterInfo;
        });
        
        const sortInfo = this.activeSortsSet;
        const options = new PreviewDataOptions(sender.pageIndex, sender.rowsPerPage, sortInfo,filters);
        
        const cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.ingestOutput);
        const request = new GetDataFarmPreviewRequest(
          cachekeyRequest.userId,
          cachekeyRequest.orgId,
          cachekeyRequest.refineryId,
          cachekeyRequest.nodeId,
          "",
          cachekeyRequest.cacheKeyType,
          options
        );
        const response = await this.configService.getOutputDataFarmPreviewAsync(request);
        if(response.data == null && response.errorMsg.length > 0) {
          throw new Error(response.errorMsg);
        } else {
          this.outputDataColumnsCount = response.data.columns.length;
          this.checkAndEnableDeltebtnforPlaceholdrCols();
          sender.bindData(response.data, 'No preview data');
        }
      }
    } catch (err) {
      this.displayError('Failed to get output data farm preview', 'Error', err);
    } finally {
      //busyIndicator.close();
      sender.isGettingData.next(false);
    }
  }

  applySorts(activeSorts: SortInfo[]){
    this.activeSortsSet = activeSorts;
  }
  
  clearAllSortFilter(){
    this.activeSortsSet = [];
    this.viewModel.activeFilters=[];
  }

  onTabClick(event: MatTabChangeEvent): void {
    const selectedTabIndex = event.index;
    const selectedTabLabel = event.tab.textLabel;
    this.selectedIndex = selectedTabIndex;
 
    // Alert the tab index and label
   // alert(`Tab clicked: ${selectedTabLabel} (Index: ${selectedTabIndex})`);
    if(selectedTabLabel.match("Raw Data") && selectedTabIndex == 0) {
      this.userData.setRawTabClicked(true);
      this.userData.setIngestInputTabClicked(false);
    } else if(selectedTabLabel.match("Input") && selectedTabIndex == 1) {
      this.userData.setRawTabClicked(false);
      this.userData.setIngestInputTabClicked(true);
    } else {
      this.userData.setRawTabClicked(false);
      this.userData.setIngestInputTabClicked(false);
    }
  }  

  async checkIfMappedColsExistsInvkInputPrevw() {
    const mappedColsList = this.viewModel.selectedIngestConfig.columnMap.filter(colMap => colMap.targetColumnName == undefined || colMap.targetColumnName.length > 0);
    if(mappedColsList.length > 0 || this.isClearMapButtonClicked) {
      await this.inputDataFarmPreviewTable.onRefreshClicked();
    } else {  
        this.displayError("Column Map cannot be empty. Please map at least one column to the target in the Input Preview.", "Error");
    }
  }

  async loadConnectorColumns() {
    const configJsonObject = this.userData.getSelectedConfigJson(); //state.config;
    //  console.log('configJsonObject', configJsonObject)
    if(configJsonObject){
      var savedIngestConfig = configJsonObject.dataConnectorMappings[0];//.filter( item => item.guid === this.viewModel.selectedIngestConfig.guid)[0];
    }
     await this.loadColumns();
     //Check if there are any Placeholder Columns not mapped to target column type, and then remove the rows having placeholder column and displays warning.
     this.showPlaceholderNotMappedWarning("mapper");
      var confirmTitle = '' ;
      var confirmmessage = '' ;
      // console.log('loading Data Connector selectedIngestConfig.', this.viewModel.selectedIngestConfig);
      if(savedIngestConfig?.dataConnector?.filePath && this.input_File_Path != savedIngestConfig?.dataConnector?.filePath ){
          if(this.isAutoMapApplied) {
            if(!this.viewModel.selectedIngestConfig.matchAllColumns ){
              //console.log(this.viewModel.selectedIngestConfig.columnMap) 
              const autoMappedTargetColsList = this.viewModel.selectedIngestConfig.columnMap.filter(colMap => colMap.targetColumnName.length > 0)
              // console.log(autoMappedTargetColsList)
              if(autoMappedTargetColsList.length > 0) {
                confirmTitle = 'Auto Match.' ;
                confirmmessage = 'Some fields that were not mapped in the previous Ingest farm are now mapped in the current Ingest farm using AutoMapper.';
              } else {
                if(this.viewModel.selectedIngestConfig.getFileDataConnector().inputFileName)
                {
                confirmTitle = 'No Match.' ;
                confirmmessage = 'None of the fields that were mapped in the previous Ingest farm in the current Ingest farm, therefore there are no mapped fields.' ;
              }             
              }
            }else if(this.viewModel.selectedIngestConfig.notMatchingColumns.length > 0){
              let commaSeparatedString: string = this.viewModel.selectedIngestConfig.notMatchingColumns.join(', ');
              // this.displayInfo(`The following fields (${commaSeparatedString}) were mapped in the previous ingest farm and are in the current ingest farm.`,'Partial Match ')
              confirmTitle = 'Partial Match.' ;
              confirmmessage = `The following fields (${commaSeparatedString}) were mapped in the previous ingest farm and are in the current ingest farm.` ;
            }
          }
          if(confirmTitle != '' && confirmmessage!= ''){
            this.showConfirmDialog(confirmTitle, confirmmessage, async (confirmed) => {
              if (confirmed) {
                this.saveIngest.emit(this.userData.getSelectedNodeDetails().name);
              }
              else{
                await this.loadColumns('Previous');
              }
            });
          }
        } 
  }

  runAutoMapper(): void {
    this.isClearMapButtonClicked = false;
    this.isLoadConnectorColumnsClicked = false;
    this.isAutoMapApplied = true;
    // this.updateingestnodestatusService.invokeUpdateIngestNodeStatus();
    this.sharedService.sendEvent("mapper_updated");
    this.loadConnectorColumns();
    this.onPanelOpened('mapper', false, false);
  }

  mapSelector(): void {
    this.isAutoMapApplied = false;
    // Remember whether the mapper was cleared before opening the Map Library, so a
    // Cancel can restore that cleared state rather than reloading a previous mapping.
    this.clearMapStateBeforeMapLibrary = this.isClearMapButtonClicked;
    this.isClearMapButtonClicked = false;
    this.createMasterColMappingsJSON();
  }

  matchToPreviousMapping(): void {
    this.isClearMapButtonClicked = false;
    this.isLoadConnectorColumnsClicked = false;
    
    if(this.viewModel.selectedIngestConfig.dataConnectorType == 1){
      var dbTypeSelectedStatus =false;
      if(this.viewModel.selectedIngestConfig.databaseType == DatabaseType.SQL){
        dbTypeSelectedStatus = this.checkIfDatabaseTypeIsSelected(this.viewModel.selectedIngestConfig.getDatabaseConnector().databaseType);
      }else if(this.viewModel.selectedIngestConfig.databaseType == DatabaseType.Oracle){
        dbTypeSelectedStatus = this.checkIfDatabaseTypeIsSelected(this.viewModel.selectedIngestConfig.getOracleConnector().databaseType);
      }
      else if(this.viewModel.selectedIngestConfig.databaseType == DatabaseType.Vertica){
        dbTypeSelectedStatus = this.checkIfDatabaseTypeIsSelected(this.viewModel.selectedIngestConfig.getVerticaConnector().databaseType);
      }
      else if(this.viewModel.selectedIngestConfig.databaseType == DatabaseType.MySql){
        dbTypeSelectedStatus = this.checkIfDatabaseTypeIsSelected(this.viewModel.selectedIngestConfig.getMySqlConnector().databaseType);
      }
         
         if(dbTypeSelectedStatus) {
          this.createMasterColMappingsJSON();
         } else {
         // this.showDatabaseTypeNotSelectedWarning("Database Type is required !")
         this.displayError("  Database Type is required!","Warning.");
         }
    } else {
      this.createMasterColMappingsJSON();
    }
   
    this.onPanelOpened('mapper', false, true);
  }

  async createMasterColMappingsJSON() {
    const busyIndicator = this.showBusyDialog('Loading Map Data...');
    try {
      const organizationId = Number(this.userData.getOrgId());
      var current_dataConnectorType = this.viewModel.dataTransformConfigViewModel.dataConnectorType ;
      const createMasterColMappingRequest = new CreateMasterColMappingsRequest(Number(this.userData.getOrgId()));
      if(!this.viewModel.dataTransformConfigViewModel.dataConnectorType){
          current_dataConnectorType = this.viewModel.selectedIngestConfig.dataConnector['dataConnectorType']
      }
      var excelTurboMode = false;
      var isMultiTabIngest = false;
      var targetDataFarmType = this.viewModel.selectedIngestConfig.targetDataFarm;
      var dataConnector: DataConnector;
      switch (current_dataConnectorType) {
          case DataConnectorType.Database:
            if(this.viewModel.selectedIngestConfig.databaseType===DatabaseType.SQL){
              dataConnector = this.viewModel.selectedIngestConfig.getDatabaseConnector().toDataConnector();
            }else if(this.viewModel.selectedIngestConfig.databaseType===DatabaseType.Oracle){
              dataConnector = this.viewModel.selectedIngestConfig.getOracleConnector().toDataConnector();
            }else if(this.viewModel.selectedIngestConfig.databaseType===DatabaseType.Vertica){
              dataConnector = this.viewModel.selectedIngestConfig.getVerticaConnector().toDataConnector();
            }
            else if(this.viewModel.selectedIngestConfig.databaseType===DatabaseType.MySql){
              dataConnector = this.viewModel.selectedIngestConfig.getMySqlConnector().toDataConnector();
            }
            break;
          case DataConnectorType.Text:
            dataConnector = this.viewModel.selectedIngestConfig.getFileDataConnector().toDataConnector();
            break;
          case DataConnectorType.Excel:
            dataConnector = this.viewModel.selectedIngestConfig.getExcelDataConnector().toDataConnector();
            excelTurboMode = this.viewModel.selectedIngestConfig.excelTurboMode;
            isMultiTabIngest = this.viewModel.selectedIngestConfig.isMultiTabIngest;
            break;
          case DataConnectorType.Feather:
            dataConnector = this.viewModel.selectedIngestConfig.getFeatherDataConnector().toDataConnector();
            break;
          case DataConnectorType.Parquet:
            dataConnector = this.viewModel.selectedIngestConfig.getParquetDataConnector().toDataConnector();
            if(dataConnector.filePath == undefined) {
              dataConnector.filePath = "";
            }
            break;
      }
      // Check if the ingest config node guid is blank then assign the guid from dataTransformConfigViewModel.dataTransformerConfig
      if(this.ingestConfigGUID == '' && this.viewModel.dataTransformConfigViewModel.dataTransformerConfig != undefined){
        this.ingestConfigGUID = this.viewModel.dataTransformConfigViewModel.dataTransformerConfig.guid;
      }
      const unifiedColumnMappingsMapLibraryRequest = new GetUnifiedColmappingMapLibRequest(organizationId, history.state.dataSourceType, current_dataConnectorType, dataConnector, this.ingestConfigGUID, excelTurboMode, isMultiTabIngest, targetDataFarmType);
      const createMasterColMappingResponse = await this.configService.createMasterColMappings(createMasterColMappingRequest);
      // 205 signals the master column mappings cache was corrupt and has been reset.
      // Prompt the analyst to retry so the next click rebuilds it cleanly.
      if (createMasterColMappingResponse && createMasterColMappingResponse.status_code === 205) {
        busyIndicator.close();
        this.displayInfo(createMasterColMappingResponse.message, 'Map Library');
        return;
      }
      await this.configService.getUnifiedColumnMappingsMapLibrary(unifiedColumnMappingsMapLibraryRequest).then( response => {
        console.log('getUnifiedColumnMappingsMapLibrary response', response);
        if(response.masterColumnMappings) {
          busyIndicator.close();
          this.onMapLibraryClicked(response.masterColumnMappings)
        }
      });
    } catch (err) {
      this.displayError('Failed to load map library data.', 'Error', err);
      busyIndicator.close();
    }
  }

  async onMapLibraryClicked(masterColumnMappings?: MasterColumnMapping): Promise<void> {
    const busyIndicator = this.showBusyDialog('Opening Map Library...');
    console.log("onMapLibraryClicked");
    try {
      let title: string='Map Library';
      let currentNodefields: MapLibraryColmatchSelectionItem[] = [];
      let allMapsfields: MapLibraryColmatchSelectionItem[] = [];
      let dialogWidth: string='1000px';
      const currentNodeMapItemColorCode = '#98FB00';
      const allMapsItemColorCode = '#ED7D31';
      /* ---------- Current Node Columns ---------- */
      this.currentNodeMapsList.length = 0; // Clear the array before pushing new items
      masterColumnMappings.currentNodeMaps.forEach( map => {
        this.currentNodeMapsList.push(new MapLibraryColmatchSelectionItem(map.mappedId, map.fieldsmatchedmsg, map.lastModified, currentNodeMapItemColorCode, "current_node"));
      });
      currentNodefields.push(...this.currentNodeMapsList);
      /* ---------- All Map Fields ---------- */
      this.allMapsList.length = 0; // Clear the array before pushing new items
      masterColumnMappings.allMaps.forEach( map => {
        this.allMapsList.push(new MapLibraryColmatchSelectionItem(map.mappedId, map.fieldsmatchedmsg, map.lastModified, allMapsItemColorCode, "all_maps"));
      });
      allMapsfields.push(...this.allMapsList);

      busyIndicator.close();

      this.showMapLibraryDialogOption(title, currentNodefields, allMapsfields,dialogWidth, 
      async (eventname:string, selectedfield: string, selectedMapType: string) => {
        switch (eventname) {
          case 'selectfield':
            this.selectedMapType = selectedMapType;
            this.selectedIngestGUID = selectedfield;
            await this.loadConnectorColumns();
            break;

          case 'cancelmapselection': {
            // Cancel reverts the mapper to its state before the Map Library opened.
            // If Clear Map was active then, keep it cleared instead of reloading a map.
            if (this.clearMapStateBeforeMapLibrary) {
              this.isClearMapButtonClicked = true;
              await this.loadConnectorColumns();
              break;
            }
            this.selectedMapType = selectedMapType;
            const farmGUID = this.userData.getSelectedIngestFarmGUID();
            const prevGUID = this.userData.getSelectedIngestMappingGUID();
            const prevType = this.userData.getSelectedIngestMappingType();
            if (farmGUID === undefined && prevGUID === undefined) {
              this.selectedIngestGUID = "";
            } else if (prevGUID === undefined || prevGUID === "") {
              this.selectedIngestGUID = farmGUID;
            } else {
              this.selectedIngestGUID = prevGUID;
              this.selectedMapType = prevType;
            }
            await this.loadConnectorColumns();
            break;
          }

          case 'confirmmapselection':
            // Store selected mapping guid and type for revert on cancel.
            this.userData.setSelectedIngestMappingGUID(this.selectedIngestGUID);
            this.userData.setSelectedIngestMappingType(this.selectedMapType);
            break;
        }
      });
    } catch (err) {
      this.displayError('Failed to bind data in map library.', 'Error', err);
      busyIndicator.close();
    }
  }

  showMapLibraryDialogOption(
      title: string,
      currentNodefields: MapLibraryColmatchSelectionItem[],
      allMapsfields: MapLibraryColmatchSelectionItem[],
      dialogWidth: string,
      onClosed: (eventname:string, selectedfield: string, selectedMapType: string) => any): void {
  
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.data = {title, currentNodefields, allMapsfields, onClosed};
      dialogConfig.width = dialogWidth;
      dialogConfig.scrollStrategy = this.overlay.scrollStrategies.noop();
      const dialogRef = this.matDialog.open(MaplibraryComponent, dialogConfig);

      // Allow the background (mat-drawer-content) to scroll while the dialog is open.
      // Fixed-position overlays capture wheel events so they never reach mat-drawer-content;
      // we forward them manually for the lifetime of this dialog.
      const scrollTarget = document.querySelector('mat-drawer-content') as HTMLElement | null;
      const wheelHandler = (event: WheelEvent): void => {
        const dialogContainer = document.querySelector('mat-dialog-container');
        if (dialogContainer?.contains(event.target as Node)) return;
        if (scrollTarget) {
          scrollTarget.scrollTop += event.deltaY;
          scrollTarget.scrollLeft += event.deltaX;
        }
      };
      document.addEventListener('wheel', wheelHandler, { passive: true });

      dialogRef.afterClosed().subscribe(result => {
        document.removeEventListener('wheel', wheelHandler);
        onClosed(result.eventname, result.selectedfield, result.selectedMapType);
      });
  }

  clearMap(): void {
    this.showConfirmDialog(
      'Clear Column Mapping', // Title of the dialog
      'Are you sure you want to clear the mapping?', // Message of the dialog
      async (result) => {
        if (result) { // Clear the mapping only if the analyst confirms (result is true)
          this.isClearMapButtonClicked = true;
          this.isAutoMapApplied = false;
          this.sharedService.sendEvent("mapper_updated");
          await this.loadColumns();  
        }
      }
    );
  }

  checkIfDatabaseTypeIsSelected(databaseType: DatabaseType): boolean {
       if(databaseType == undefined) {
          return false
       }
     return true
  }

  async GetCacheKeyRequest(previewType:PreviewType): Promise<GetCacheKeyRequest> {
    var request = new GetCacheKeyRequest(
        this.userData.getUserId(),
        this.userData.getOrgId(),
        this.userData.getRefineryId(),
        this.userData.getNodeId(),
        "",
        CacheKeyType.ingestInput);

    if(previewType === PreviewType.ingestRaw) {
      request.cacheKeyType=CacheKeyType.ingestRaw;
    }else if (previewType === PreviewType.ingestInput) {
      request.cacheKeyType=CacheKeyType.ingestInput;
    }else if (previewType === PreviewType.ingestOutput) {
      request.cacheKeyType=CacheKeyType.node;
    }

    return request;
  }
  /*showColumnMapperWarning(): void {
    this.displayInfoHTML(
      `<ol style="margin: 0; padding-left: 20px;">
        Developer file path is required for Column Mapper.
      </ol>`,
      "Warning:"
    );
  }*/
 /* showColumnDataPreviewWarning(): void {
    this.displayInfoHTML(
      `<ol style="margin: 0; padding-left: 20px;">
        Developer file path is required for Data Preview.
      </ol>`,
      "Warning:"
    );
  }*/
/*  showColumnMapperDBWarning(): void {
    this.displayInfoHTML(
      `<ol style="margin: 0; padding-left: 20px;">
        Please check the connection.
      </ol>`,
      "Warning:"
    );
  }*/

  /*showDatabaseTypeNotSelectedWarning(msgToDisplay: string): void {
    this.displayInfoHTML(
       `<ol style="margin: 0; padding-left: 20px;">` +
          msgToDisplay 
      + `</ol>`,
      "Warning:"
    );
  }*/

async onClickExportOutput() {

  const columnMap = this.viewModel.selectedIngestConfig.columnMap;
  if (!columnMap || columnMap.length === 0) {
    this.displayWarning('No mapping available to export.', 'Export');
    return;
  }

  const headers = ['Index', 'Source Column', 'Target Column', 'Data Type', 'Python Data Type', 'Description'];
  const rows = columnMap.map(c =>
    [
      c.index,
      c.columnName,
      c.targetColumnName ?? '',
      c.dataType ?? '',
      c.pyDataType ?? '',
      c.description ?? ''
    ].join('|')
  );

  const fileContent = [headers.join('|'), ...rows].join('\n');

  const blob = new Blob([fileContent], { type: 'text/plain;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;

 
  // ✅ Build dynamic filename
  const nodeDetails = this.userData.getSelectedNodeDetails();
  const nodeNumber = nodeDetails?.rcNo ?? '';
  const nodeName = nodeDetails?.name ?? '';
  const connectorName = this.viewModel.selectedIngestConfig?.name ?? '';

  let fileName = `Ingest Node ${nodeNumber} ${nodeName} ${connectorName}`;

  // Replace spaces with underscores
  fileName = fileName.replace(/\s+/g, '_');

  // Remove invalid filename characters
  fileName = fileName.replace(/[<>:"/\\|?*]+/g, '');

  a.download = `${fileName}.txt`;
  a.click();

  window.URL.revokeObjectURL(url);

}
}